import { SettingService } from 'src/app/shared/services/setting.service';
import { GetGeneralCountByProfileId, ProfileAdditionDetail, ProfileAdditionDetailForOpportunity } from './../../profile-management/profile-detail.model';
import { CurrencyFormatPipe } from './../../../../shared/pipes/currency-format.pipe';
import { NumberFormatPipe } from './../../../../shared/pipes/number-format.pipe';
import { SaleAccountService } from './../../sale-account-management/sale-account.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { AfterViewInit, ChangeDetectorRef, Component, ComponentFactoryResolver, ComponentRef, ElementRef, EventEmitter, Inject, Input, NgZone, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, TemplateRef, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatMenuTrigger } from '@angular/material/menu';
import { NbAuthJWTToken, NbAuthService } from '@nebular/auth';
import { NbPopoverDirective, NbToastrService, NbWindowService } from '@nebular/theme';
import { Observable, Subject, Subscription, timer } from 'rxjs';
import { debounceTime, finalize, map, startWith, take, takeUntil, tap } from 'rxjs/operators';
import { TblActionType } from 'src/app/shared/enums/tbl-action-type.enum';
import { ReturnResult } from 'src/app/shared/models/return-result';
import { CallService } from 'src/app/shared/services/call.service';
import { Helper } from 'src/app/shared/utility/Helper';
import { Contact, KeyPairsValueSelectDropDown, ProfileDetailModel } from '../../profile-management/profile-detail.model';
import { LinkscopeEmailComponent } from '../../profile-management/profile-detail/action-block/linkscope-email/linkscope-email.component';
import { AutomateDatastateService } from '../../profile-management/profile-detail/automate-datastate-log/automate-datastate.service';
import { ProfileService } from '../../profile-management/profile.service';
import { AddEditTaskComponent } from '../../task-management/add-edit-task/add-edit-task.component';
import { TaskBoardService } from '../../task-management/task-board/task-board.service';
import { UserService } from '../../user-management/user.service';
import { OpportunityManagementService } from '../opportunity-management.service';
import { AddProfileVendorViewModel, ProposalArtists, ProposalNonArtistFeeInputModel, ProposalRevision, ProposalWhiteLabelData, SaleOpportunity } from '../opportunity.model';
import { NumericValueType, RxwebValidators } from '@rxweb/reactive-form-validators';
import { EntityColorEnums } from 'src/app/shared/enums/entity-color.enums';
import { NoteTabComponent } from 'src/app/shared/components/note-tab/note-tab.component';
import { NoteDetails } from 'src/app/shared/components/note-management/noteManagement.model';
import { ActivatedRoute, Router } from '@angular/router';
import { permissionGridNoteOpportunity, permissionNonArtistExpenses, permissionNonArtistIncome, permissionSaleOpportunityFile } from 'src/app/shared/contances/permission';
import { OverlayNoteDetailsComponent } from 'src/app/shared/components/note-management/overlay-note-details/overlay-note-details.component';
import { NoteManagementService } from 'src/app/shared/components/note-management/note-management.service';
import { ShadowProfileEnum } from 'src/app/shared/enums/shadow-profile.enum';
import { UserModel } from '../../user-management/user-model';
import { DynamicContentService } from 'src/app/shared/services/dynamic-content.service';
import { DynamicContentModel } from 'src/app/shared/models/dynamic-content.model';
import { ProfileAdditionDetailService } from 'src/app/shared/services/profile-addition-detail.service';
import { HotToastService } from '@ngneat/hot-toast';
import { ProfileFileTabComponent } from 'src/app/shared/components/stand-alone-component/profile-file-tab/profile-file-tab.component';
import { UserUploadManagementService } from '../../user-upload-management/user-upload-management.service';
import { UserUpload } from '../../user-upload-management/user-upload.model';
import { ConfirmModalComponent } from 'src/app/shared/components/confirm-modal/confirm-modal.component';
import { TaskGridByProfileIdComponent } from '../../sale-lead-management/sale-lead-details/task-grid-by-profile-id/task-grid-by-profile-id.component';
import { ContactPage, Page } from 'src/app/shared/models/paging/page';
import { ReviewContactCampaignComponent } from '../../email-campaign-management/email-campaign-detail/create-new-campaign/review-contact-campaign/review-contact-campaign.component';
// import { AdminTabModeService } from 'src/app/shared/components/stand-alone-component/admin-tab-mode/admin-tab-mode.service';
// import { TabTagIndexModel } from 'src/app/shared/components/stand-alone-component/admin-tab-mode/tab-mode.model';
import { SettingPoolService } from 'src/app/shared/services/setting-pool.service';
import { environment } from 'src/environments/environment';
import { PrimasSendSMSComponent } from 'src/app/shared/components/template-management/primas-send-sms/primas-send-sms.component';
import { AddEditProposalNonArtistIncomeComponent } from '../non-artist-income/add-edit-proposal-non-artist-income/add-edit-proposal-non-artist-income.component';
import { NonArtistIncomeComponent } from '../non-artist-income/non-artist-income.component';
import { AddSaleAccountComponent } from '../../sale-account-management/add-sale-account/add-sale-account.component';
import { OpportunityContactTabComponent } from '../opportunity-details/opportunity-contact-tab/opportunity-contact-tab.component';
import { ArtistTabComponent } from '../opportunity-details/artist-tab/artist-tab.component';
import { ProposalRevisionTabComponent } from '../opportunity-details/proposal-revision-tab/proposal-revision-tab.component';
import { NbAccessChecker } from '@nebular/security';
import { AddEditArtistComponent } from '../opportunity-details/artist-tab/add-edit-artist/add-edit-artist.component';
import { ProposalArtistTemplateComponent } from '../opportunity-details/proposal-artist-template/proposal-artist-template.component';
import { UploadUrlComponent } from 'src/app/shared/components/stand-alone-component/profile-file-tab/upload-url/upload-url.component';
import { SignalrDynamicService } from 'src/app/shared/services/signalr-dynamic.service';
import { CrmCallStatusComponent } from './crm-call-status/crm-call-status.component';
import { QuillEditorComponent } from 'ngx-quill';
import { QuillConfiguration } from 'src/app/shared/components/stand-alone-component/rich-inline-edit/rich-inline-edit.component';
import { DatePipe } from '@angular/common';
import { ActivityTimelineComponent } from 'src/app/shared/components/activity-timeline/activity-timeline.component';
import { CRMTaskService } from './crm-task.service';
import { DragBlockScreenComponent } from 'src/app/shared/components/drag-block-screen/drag-block-screen.component';
import { CrmTaskTemplateComponent } from './crm-task-template/crm-task-template.component';
import { ContactRelationshipGridComponent } from 'src/app/shared/components/contact-relationship-grid/contact-relationship-grid.component';
import { CrmInlineNoteComponent } from './crm-inline-note/crm-inline-note.component';
import { CrmLostReasonComponent } from './crm-lost-reason/crm-lost-reason.component';
import { UserExperienceTrackingService } from 'src/app/shared/components/user-experience-tracking/user-experience-tracking.service';
import { MicrosoftOffice365Service } from '../../../../shared/services/microsoft-office-365.service';
import {
  AddExistingProfileComponent,
  EDIT_EXISTING_PROFILE_ACTION,
  EditExistingProfileSelection
} from '../../producer-management/add-edit-producer/producer-profile-tab/add-existing-profile/add-existing-profile.component';
import { ProfileVendorComponent } from '../opportunity-details/profile-vendor/profile-vendor.component';
import {
  openEditProfileVendorDialog,
  preloadEditProfileVendorDialog
} from '../opportunity-details/profile-vendor/edit-profile-vendor/edit-profile-vendor-dialog.composable';
import { ProfileVendorModel } from '../opportunity-details/profile-vendor/profile-vendor.model';
import { AutomationScreenComponent } from 'src/app/shared/components/automation-screen/automation-screen.component';
import { LocationService } from 'src/app/shared/components/stand-alone-component/location/location.service';
import { SaleAccountDetailModel } from '../../sale-account-management/sale-account.model';
import { ContactService } from 'src/app/shared/services/contact.service';
import { DropDownValue } from '../../summary-report/summary-report.component';
import { mountProposalHistoryGrid } from 'src/app/shared/components/proposal-history-grid/proposal-history-grid.composable';
import {
  disposeProposalHistoryModalShellBindings,
  mountProposalHistoryModalShell,
  ProposalHistoryModalShellBindings,
  syncProposalHistoryModalShellState,
} from 'src/app/shared/components/proposal-history-modal-shell/proposal-history-modal-shell.composable';
import { InquiryHistoryModalFacadeService } from './proposal-history-widget/inquiry-history-modal.facade.service';
import { mountCrmProposalHistoryWidget } from './proposal-history-widget/crm-proposal-history-widget.composable';
import {
  CrmProposalHistoryWidgetStore,
  PROPOSAL_HISTORY_GRID_DATA_SOURCE,
  ProposalHistoryRepositoryAdapter,
} from 'src/app/shared/stores';
import { openContractVaultDialog } from 'src/app/shared/components/contract-vault-dialog/contract-vault-dialog.composable';

export const ARTIST_PROPOSAL_COMMIT_EVENT = 'app://artist-proposal-commit';

export const ARTIST_PROPOSAL_COMMIT_ACK_EVENT = 'app://artist-proposal-commit-ack';

interface ArtistProposalCommitItem {
  id: string;
  quotedPrice: number;
}

interface ArtistProposalCommitPayload {
  artists: ArtistProposalCommitItem[];
  mode: string;
  timestamp: string;
}

interface ArtistProposalCommitMessage {
  type: typeof ARTIST_PROPOSAL_COMMIT_EVENT;
  payload: ArtistProposalCommitPayload;
  requestId?: string | number;
  id?: string | number;
}

interface ArtistProposalCommitAckMessage {
  type: typeof ARTIST_PROPOSAL_COMMIT_ACK_EVENT;
  payload: {
    status: 'ok';
    message: string;
    receivedAt: string;
    requestId?: string | number;
  };
}

interface InquiryHistoryRuntimeState {
  gridRef: ComponentRef<any> | null;
  shellRef: ComponentRef<any> | null;
  shellBindings: ProposalHistoryModalShellBindings | null;
  navigateSub: Subscription | null;
}

/**
 * ## CRM Opportunity Details
 *
 * Large feature container for opportunity CRM workflows.
 *
 * ### Proposal-History/Lazy-Load Scope in this file
 * - Provides a feature-scoped `CrmProposalHistoryWidgetStore` (not global singleton).
 * - Lazily mounts summary widget (`crm-proposal-history-widget`) in header region.
 * - Lazily mounts full history grid into modal dialog when requested by widget.
 *
 * @component `app-crm-opportunity-details`
 * @focus `proposal-history consumer orchestration`
 * @see {@link CrmProposalHistoryWidgetStore}
 * @see {@link ProposalHistoryRepositoryAdapter}
 * @see {@link PROPOSAL_HISTORY_GRID_DATA_SOURCE}
 */
@Component({
  selector: 'app-crm-opportunity-details',
  templateUrl: './crm-opportunity-details.component.html',
  styleUrls: ['./crm-opportunity-details.component.scss'],
  providers: [
    ProposalHistoryRepositoryAdapter,
    CrmProposalHistoryWidgetStore,
    InquiryHistoryModalFacadeService,
    { provide: PROPOSAL_HISTORY_GRID_DATA_SOURCE, useExisting: CrmProposalHistoryWidgetStore },
  ],
})
export class CrmOpportunityDetailsComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  private static readonly LOAD_ALL_WARNING_THRESHOLD = 100;
  @Input() id: string = null;
  @Input() openByDialog = false;
  @Input() enableCloseBtn = true;
  @Input() optionalTaskId: string = null;
  @Input() creatableTask = true;
  @Input() onNoteInlineChanged: EventEmitter<boolean>;
  @Input() onCloseLostReasonChange: EventEmitter<boolean>;

  @Output() saleOpportunityEmit: EventEmitter<SaleOpportunity> = new EventEmitter<SaleOpportunity>();
  @Output() onClose: EventEmitter<boolean> = new EventEmitter();
  @Output() onAdvancedImport: EventEmitter<any> = new EventEmitter();
  @Output() refreshTask: EventEmitter<void> = new EventEmitter();

  @ViewChild(MatMenuTrigger, { static: false }) menuStage: MatMenuTrigger;
  noteTab: NoteTabComponent;
  @ViewChild('gridNoteTab', { static: false }) set setGridNoteTab(content: NoteTabComponent) { if (content) this.noteTab = content };
  contactTab: ContactRelationshipGridComponent;
  @ViewChild('contactGrid', { static: false }) set contactAccount(content: ContactRelationshipGridComponent) { if (content) this.contactTab = content };
  artistTab: ArtistTabComponent;
  @ViewChild('artistGrid', { static: false }) set artistGrid(content: ArtistTabComponent) { if (content) this.artistTab = content };
  fileTab: ProfileFileTabComponent;
  @ViewChild('profileFileTab', { static: false }) set setProfileFileTab(content: ProfileFileTabComponent) { if (content) this.fileTab = content }
  vendorTab: ProfileVendorComponent;
  @ViewChild('profileVendorGrid', { static: false }) set vendorGrid(content: ProfileVendorComponent) { if (content) this.vendorTab = content };
  nbMailPopover: NbPopoverDirective;
  @ViewChild('sendMailBtn', { static: false }) set setSendMailBtn(content: NbPopoverDirective) { if (content) this.nbMailPopover = content }
  makeCallPopover: NbPopoverDirective;
  @ViewChild('makeCallPopoverBtn', { static: false }) set setMakeCallBtn(content: NbPopoverDirective) { if (content) this.makeCallPopover = content }
  sendSMSPopover: NbPopoverDirective;
  @ViewChild('sendSMSBtn', { static: false }) set setSendSMSBtn(content: NbPopoverDirective) { if (content) this.sendSMSPopover = content }

  taskGrid: TaskGridByProfileIdComponent;
  @ViewChild('taskGrid', { static: false }) set setTaskGrid(content: TaskGridByProfileIdComponent) { if (content) this.taskGrid = content };

  proposalNonArtistTab: NonArtistIncomeComponent;
  @ViewChild('proposalNonArtistTab', { static: false }) set setProposalNonArtist(content: NonArtistIncomeComponent) { if (content) this.proposalNonArtistTab = content };

  proposalRevision: ProposalRevisionTabComponent;
  @ViewChild('proposalRevision', { static: false }) set setproposalRevision(content: ProposalRevisionTabComponent) { if (content) this.proposalRevision = content };

  @ViewChild('contactSelectPop', { static: true }) contactSelectPop: TemplateRef<any>;

  nbFilesPopover: NbPopoverDirective;
  @ViewChild('nbFilesBtn', { static: false }) set setFilesPopoverBtn(content: NbPopoverDirective) { if (content) this.nbFilesPopover = content }

  @ViewChild('createNewTask', { static: true }) createNewTask: TemplateRef<any>;
  @ViewChild('popupEditor') popupEditor: TemplateRef<any>;
  @ViewChild('quillEditor', { static: false }) set setQuillEditor(content: QuillEditorComponent) {
    if (content) this.quillEditor = content
  }

  activityLogTimeline: ActivityTimelineComponent;
  @ViewChild('activityLogTimeline', { static: false }) set setActivityLogTimeline(content: ActivityTimelineComponent) { if (content) this.activityLogTimeline = content };

  noteCard: TemplateRef<any>;
  @ViewChild('noteCard', { static: false }) set noteCardContent(content: TemplateRef<any>) { if (content) this.noteCard = content };

  headerCallDialog: TemplateRef<any>;
  @ViewChild('headerCallDialog', { static: false }) set headerCallDialogContent(content: TemplateRef<any>) { if (content) this.headerCallDialog = content };

  inlineNote: CrmInlineNoteComponent;
  @ViewChild('inlineNote', { static: false }) set inlineNoteContent(content: CrmInlineNoteComponent) { if (content) this.inlineNote = content };

  @ViewChild('noteContainer') noteContainer: ElementRef;
  get noteContainerElement(): HTMLElement {
    return this.noteContainer.nativeElement;
  }
  @ViewChild('whiteLabelConfirmation') whiteLabelConfirmation: TemplateRef<any>;
  @ViewChild('copyExternalProposalUrl') copyExternalProposalUrl: TemplateRef<any>;

  statusCallComponent: CrmCallStatusComponent;
  @ViewChild('statusCallComponent', { static: false }) set setStatusCallComponent(content: CrmCallStatusComponent) {
    if (content) this.statusCallComponent = content;
  };

  lostReasonComponent: CrmLostReasonComponent;
  @ViewChild('inlineLostReason', { static: false }) set setInlineLostReason(content: CrmLostReasonComponent) { if (content) this.lostReasonComponent = content };

  resourceProposalNonArtistIncome = permissionNonArtistIncome;
  resourceProposalNonArtistExpenses = permissionNonArtistExpenses;
  environment = environment;
  handleAutomate: boolean = false;
  isCopy = false;
  opportunityModel: ProfileDetailModel;
  proposalNonArtist: ProposalNonArtistFeeInputModel;
  user: any = null;
  isLoading: boolean = false;
  isRefreshing: boolean = false;
  isLoadingEdit: boolean = false;
  isCalling: boolean = false;
  isCallLoading: boolean = false;
  isClosing: boolean = false;
  selectTab: TabOpportunity = TabOpportunity.Artist;
  lostTypeId: number = 0;
  wonTypeId: number = 0;
  getPercentageProfitSetting: number = 0;
  /**
   * @deprecated This property no more be used but kept for legacy call
   */
  colorTextDisplay: string = '';
  /**
   * @deprecated This property no more be used but kept for legacy call
   */
  calculatePercentProfit: number = 0;
  isShowSwitchEventDateButton: boolean = false;
  showCloseDateInput: boolean = true;
  public get TypeEditModelOpportunity(): typeof TypeEditModelOpportunity { return TypeEditModelOpportunity; }
  formatValueQueryType = { key: 'automateDataStateId', value: 'dataStateName', color: 'colorCode', order: 'order', groupPlaceholder: 'groupPlaceholder' };
  listStage: KeyPairsValueSelectDropDown[] = [];
  currentStage: KeyPairsValueSelectDropDown = null;
  opportunityEnums = EntityColorEnums;
  rootWhiteLabelUrl: string = "";
  proposalWhiteLabelData: ProposalWhiteLabelData;
  getWhiteLabelLoading: boolean = false;
  validProperties = {
    opportunityName: { valid: [RxwebValidators.required()], message: `${this.environment.titleOpportunity} name is required` },
    probability: {
      valid: [
        RxwebValidators.numeric({
          acceptValue: NumericValueType.Both,
          allowDecimal: true
        }),
        RxwebValidators.pattern({
          expression: { probability: /^[+-]?([0-9]{1,})?[.,]?([0-9]{1,})$/ }
        })
      ],
      message: "Probability is not valid"
    },
    amount: {
      valid: [
        RxwebValidators.numeric({
          acceptValue: NumericValueType.Both,
          allowDecimal: true
        }),
        RxwebValidators.pattern({
          expression: { amount: /^[+-]?([0-9]{1,})?[.,]?([0-9]{1,})$/ }
        })
      ], message: `${environment.titleEstimate} is not valid`
    },
    oneTimeProduct: {
      valid: [
        RxwebValidators.numeric({
          acceptValue: NumericValueType.Both,
          allowDecimal: true
        }),
        RxwebValidators.pattern({
          expression: { oneTimeProduct: /^[+-]?([0-9]{1,})?[.,]?([0-9]{1,})$/ }
        })
      ], message: `${environment.title1xProduct} is not valid`
    },
    oneTimeService: {
      valid: [
        RxwebValidators.numeric({
          acceptValue: NumericValueType.Both,
          allowDecimal: true
        }),
        RxwebValidators.pattern({
          expression: { oneTimeService: /^[+-]?([0-9]{1,})?[.,]?([0-9]{1,})$/ }
        })
      ], message: `${environment.title1xService} is not valid `
    },
    arr: {
      valid: [
        RxwebValidators.numeric({
          acceptValue: NumericValueType.Both,
          allowDecimal: true
        }),
        RxwebValidators.pattern({
          expression: { arr: /^[+-]?([0-9]{1,})?[.,]?([0-9]{1,})$/ }
        })
      ], message: "ARR is not valid"
    },
    termOfContract: {
      valid: [
        RxwebValidators.numeric({
          acceptValue: NumericValueType.Both,
          allowDecimal: true
        }),
        RxwebValidators.pattern({
          expression: { termOfContract: /^[+-]?([0-9]{1,})?[.,]?([0-9]{1,})$/ }
        })
      ], message: "Term Of Contract is not valid"
    },
    artistFeesToClient: {
      valid: [
        RxwebValidators.numeric({
          acceptValue: NumericValueType.Both,
          allowDecimal: true
        }),
        RxwebValidators.pattern({
          expression: { artistFeesToClient: /^[+-]?([0-9]{1,})?[.,]?([0-9]{1,})$/ }
        })
      ], message: `Artist Fees To Client is not valid `
    },
  }


  private routeSub: Subscription;
  currentUrl: string = '';
  fullUrl = null;
  apiGetSearchRelationship: (data) => void = null;
  contactDialogRef: any;
  existingContactDialogRef: MatDialogRef<any, any>;
  private destroy$: Subject<void> = new Subject<void>();
  isHasPrimaryContact: boolean = false;
  resource = permissionGridNoteOpportunity;
  overlayNoteDetails: OverlayNoteDetailsComponent;
  prefixCurrency: string;
  ownerModel: UserModel;
  saleAccountOwnerModel: UserModel;
  isCalculate: boolean = false;
  dynamicContentTypeAPI: Observable<ReturnResult<DynamicContentModel[]>>;
  dynamicContentCompanyAPI: Observable<ReturnResult<DynamicContentModel[]>>;
  dynamicContentLeadSourceAPI: Observable<ReturnResult<DynamicContentModel[]>>;
  mathEquation: string = '';
  uploadedFile: any;
  uploading: boolean = false;
  fileResource = permissionSaleOpportunityFile;
  apiGetSearchOwner: (data) => void = (data) => this.userService.searchUser(data);
  isTabMode = Helper.checkTabMode();
  isShowButton: boolean = false;
  contacts: Contact[] = null;
  quill: any; // Type Quill model
  quillEditor: QuillEditorComponent;
  editorOptions = QuillConfiguration;
  changeText: boolean = false;
  dialogQuillEditor: MatDialogRef<any, any>;
  contentQuillEditor = "";
  resetContacts: () => void = () => this.contacts = null;

  isDisableProduct: boolean = true;
  backOfficeUrl: string;
  isExpend: boolean = true;
  tabInfo: string = 'proposal';
  isOpenCallNote: boolean = false;
  rawLocation = [];
  locationCountries = [];
  locationStates = [];
  filteredCountries: string[] = [];
  filteredStates: string[] = [];

  dynamicContentPhoneNumber: Observable<ReturnResult<DynamicContentModel[]>>
    = this.dynamicContentService.getDynamicContentByType('general_phone');
  dynamicContentWebsite: Observable<ReturnResult<DynamicContentModel[]>>
    = this.dynamicContentService.getDynamicContentByType('general_webpage');
  dynamicContentEmail: Observable<ReturnResult<DynamicContentModel[]>>
    = this.dynamicContentService.getDynamicContentByType('general_email');
  dynamicContentIndustryAPI: Observable<ReturnResult<DynamicContentModel[]>>
    = this.dynamicContentService.getDynamicContentByType('general_industry');
  isOnTheCall: boolean = false;
  isUserClosePopNote: boolean = false;
  dialogCallNote: MatDialogRef<DragBlockScreenComponent, any>;
  isCheckingProposalPrevision: boolean = false;
  totalTask: number = 0;
  totalFile: number = 0;
  totalContact: number;
  refreshTotalValueType = {
    task: "task",
    contact: "contact",
  }
  useNewUI: boolean = false;
  proposalOption: string = "Default";
  whiteLabelUrl: string = "";
  checkingOneDriveDataSubscription: Subscription;
  isDoingCheckingOneDriveData: boolean = false;
  generalCount: GetGeneralCountByProfileId[] = []; //
  isOpenFollowUpTask: boolean = false;
  isCRMMode: string = "0";
  lastContact: string;
  isLoadingLastContact: boolean = false;
  isEnableAutomation: boolean = false;
  isAiOptimizeLoading: boolean = false;
  crmInquiryWidgetRef: ComponentRef<any> | null = null;
  inquiryWidgetCompositeState = {
    loading: false,
    loadError: false,
  };
  private inquiryHistoryLoadAll = false;
  private inquiryHistoryBodyLoading = false;
  private inquiryHistoryBodyError = false;
  proposalWidgetOpenSub: Subscription | null = null;
  @ViewChild('inquiryWidgetAnchor', { read: ElementRef }) inquiryWidgetAnchor?: ElementRef<HTMLElement>;
  @ViewChild('inquiryWidgetHost', { read: ViewContainerRef }) inquiryWidgetHost?: ViewContainerRef;
  showInquiryHistoryWidget: boolean = false;
  isInquiryHistoryWidgetMinimized: boolean = false;
  inquiryHistoryRuntime: InquiryHistoryRuntimeState = {
    gridRef: null,
    shellRef: null,
    shellBindings: null,
    navigateSub: null,
  };
  @ViewChild('inquiryHistoryShellHost', { read: ViewContainerRef }) inquiryHistoryShellHost?: ViewContainerRef;
  @ViewChild('inquiryHistoryDialog', { static: false }) inquiryHistoryDialog?: TemplateRef<any>;
  private inquiryHistoryRenderScheduled = false;
  private artistProposalAllowedOrigin: string | null = null;
  private automationDialogRef: MatDialogRef<AutomationScreenComponent, any> | null = null;
  private readonly handleArtistProposalWindowMessage = async (event: MessageEvent) => {
    if (!this.artistProposalAllowedOrigin || event.origin !== this.artistProposalAllowedOrigin) return;

    const data = event?.data as unknown;
    if (!this.isArtistProposalCommitMessage(data)) return;

    const isAckSent = await this.replyArtistProposalCommitAck(event, data);
    if (!isAckSent) return;

    try {
      await this.onArtistProposalCommitReceived(data.payload);
    } catch {
      return;
    }

    this.automationDialogRef?.close(true);
  };

  get isLoadAllInquiryHistory(): boolean {
    return this.inquiryHistoryLoadAll;
  }

  get isLoadingInquiryHistoryWidget(): boolean {
    return this.inquiryHistoryBodyLoading;
  }

  get hasInquiryHistoryGridLoadError(): boolean {
    return this.inquiryHistoryBodyError;
  }

  private isArtistProposalCommitMessage(data: unknown): data is ArtistProposalCommitMessage {
    if (!data || typeof data !== 'object') return false;

    const message = data as Partial<ArtistProposalCommitMessage>;
    if (message.type !== ARTIST_PROPOSAL_COMMIT_EVENT) return false;

    return this.isArtistProposalCommitPayload(message.payload);
  }

  private isArtistProposalCommitPayload(payload: unknown): payload is ArtistProposalCommitPayload {
    if (!payload || typeof payload !== 'object') return false;

    const commitPayload = payload as Partial<ArtistProposalCommitPayload>;
    if (!Array.isArray(commitPayload.artists)) return false;
    if (typeof commitPayload.mode !== 'string') return false;
    if (typeof commitPayload.timestamp !== 'string') return false;

    return commitPayload.artists.every((item: Partial<ArtistProposalCommitItem>) =>
      !!item
      && typeof item.id === 'string'
      && typeof item.quotedPrice === 'number'
      && Number.isFinite(item.quotedPrice)
    );
  }

  private async onArtistProposalCommitReceived(payload: ArtistProposalCommitPayload): Promise<void> {
    try {
      if (!this.id) throw new Error('Opportunity id is missing.');

      const automateDataState = await this.getDefaultArtistAutomateDataState();
      if (automateDataState === null) {
        throw new Error('DEFAULT_ARTIST_AUTOMATE_DATA_STATE is missing or invalid.');
      }

      const artistsToSave = payload.artists
        .filter(item => !!item?.id?.trim())
        .map((item, index) => {
          const proposalArtist = new ProposalArtists();
          proposalArtist.id = 0;
          proposalArtist.proposalId = this.id;
          proposalArtist.profileId = item.id.trim();
          proposalArtist.automateDataState = automateDataState;
          proposalArtist.quantity = 1;
          proposalArtist.artistFee = item.quotedPrice.toString();
          return proposalArtist;
        });

      if (artistsToSave.length === 0) {
        throw new Error('No valid artists in commit payload.');
      }

      const saveResult = await this.opportunityService.saveMultipleProposalArtists(artistsToSave).toPromise();
      if (!saveResult?.result) {
        const saveMessage = (saveResult as any)?.message || (saveResult as any)?.Message || 'Saved failed';
        throw new Error(saveMessage);
      }

      this.toast.success('', 'Saved successfully');
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Saved failed';
      console.error('[ArtistProposal] Save multiple artists failed:', error);
      this.toast.danger('', errorMessage || 'Saved failed');
      throw error;
    }
  }

  private async getDefaultArtistAutomateDataState(): Promise<number | null> {
    const defaultArtistDatastate = await this.settingService
      .getSettingByKeyAndGroup('DEFAULT_ARTIST_AUTOMATE_DATA_STATE', 'PROFILE')
      .toPromise();

    const rawValue = defaultArtistDatastate?.result?.value;
    if (rawValue === null || rawValue === undefined || rawValue === '') {
      return null;
    }

    const parsedValue = Number(rawValue);
    return Number.isFinite(parsedValue) ? parsedValue : null;
  }

  private async replyArtistProposalCommitAck(event: MessageEvent, message: ArtistProposalCommitMessage): Promise<boolean> {
    const source = event.source as WindowProxy | null;
    if (!source || typeof source.postMessage !== 'function') return false;

    const requestId = message.requestId ?? message.id;
    const ackData: ArtistProposalCommitAckMessage = {
      type: ARTIST_PROPOSAL_COMMIT_ACK_EVENT,
      payload: {
        status: 'ok',
        message: 'parent received commit',
        receivedAt: new Date().toISOString(),
      },
    };

    if (requestId !== undefined && requestId !== null) {
      ackData.payload.requestId = requestId;
    }

    source.postMessage(ackData, event.origin);
    return true;
  }

  estimatePipelineThreshold: number = 70;

  saleAccountModel: SaleAccountDetailModel;
  amountOpportunityValue: number = 0;
  amountCurrentValue: number = 0;
  isShowAllWebPage: boolean = false;
  defaultWebPageItemToShow: number = 2;
  isAddNewWebPage: boolean = false;
  newWebPageValue: string = null;
  focusOnClickAddNewWebPage: boolean = false;
  isLoadingDeleteWebpage: boolean = false;
  accountContactTypes: any[] = [];
  allContactTypesAsDropdownModel: any[] = [];
  parentContactTypeAsDropdownModel: any[] = [];
  subContactTypeAsDropdownModel: any[] = [];
  selectedContactTypeParent: any;
  selectedContactTypeChild: any;
  selectType: number[] = [];
  formatContactTypeQuery = { key: 'contactTypeId', value: 'contactTypeName', color: 'contactTypeColorCode', parentId: 'parentId' };
  getContactType = this.contactService.GetAllContactTypeAsync("ACCOUNT")
    .pipe(tap(x => {
      if (x.result) {
        this.accountContactTypes = x.result;
        this.parentContactTypeAsDropdownModel = this.accountContactTypes.slice().filter(x => x.parentId == 0).map(x => {
          return new DropDownValue(x.contactTypeName, x.contactTypeId.toString(), x.contactTypeColorCode);
        });
      }
    }), map((vals: any) => Helper.mapArrayToFormat(this.formatContactTypeQuery, vals.result)));
    
  titleOpportunity: string = environment?.titleOpportunity || 'Proposal';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialModalRef: MatDialogRef<CrmOpportunityDetailsComponent>,
    private opportunityService: OpportunityManagementService,
    private profileAdditionService: ProfileAdditionDetailService,
    private clipboard: Clipboard,
    private toast: NbToastrService,
    private dialog: MatDialog,
    private userService: UserService,
    private contactService: ContactService,
    private callService: CallService,
    private authService: NbAuthService,
    private profileService: ProfileService,
    private settingService: SettingService,
    private automateDataStateService: AutomateDatastateService,
    private accountService: SaleAccountService,
    public numPipe: NumberFormatPipe,
    private router: Router,
    public noteService: NoteManagementService,
    public currencyFormat: CurrencyFormatPipe,
    public dynamicContentService: DynamicContentService,
    private userUploadService: UserUploadManagementService,
    private hotToast: HotToastService,
    private numberPipe: NumberFormatPipe,
    private settingPoolService: SettingPoolService,
    private accessChecker: NbAccessChecker,
    private signalrService: SignalrDynamicService,
    private datePipe: DatePipe,
    private crmTaskService: CRMTaskService,
    private userExperienceTrackingService: UserExperienceTrackingService,
    private microsoftOffice365Service: MicrosoftOffice365Service,
    private locationService: LocationService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private ngZone: NgZone,
    private changeDetectorRef: ChangeDetectorRef,
    private proposalHistoryStore: CrmProposalHistoryWidgetStore,
    private inquiryHistoryModalFacade: InquiryHistoryModalFacadeService,
  ) {
    this.id = this.data?.model?.profileId ?? this.id;
    this.openByDialog = this.data?.openByDialog;

    this.isLoading = true;
    if (this.id) {
      this.refreshData();
    }

    this.authService.onTokenChange()
      .subscribe((token: NbAuthJWTToken) => {
        if (token.isValid()) {
          this.user = token.getPayload();
        }
      });
    this.apiGetSearchRelationship = (data) => this.accountService.searchSaleAccount(data);

    this.automateDataStateService.getOpportunityDataState()
      .pipe(map((vals: ReturnResult<any[]>) => Helper.mapArrayToFormat(this.formatValueQueryType, vals.result)))
      .subscribe(res => {
        if (res && res.length > 0) {
          this.listStage = [...res.map(x => x as KeyPairsValueSelectDropDown)];
          if (!this.currentStage && this.opportunityModel)
            this.currentStage = this.listStage.find(x =>
              parseInt(x.key) == (this.opportunityModel?.automateDataStateId ?? 0)
            );

          this.checkStateOpportunity();
        }
      });
    this.dynamicContentTypeAPI = this.dynamicContentService.getDynamicContentByType('opportunity-type');
    this.dynamicContentLeadSourceAPI = this.dynamicContentService.getDynamicContentByType('opportunity-leadsource');
    this.dynamicContentCompanyAPI = this.dynamicContentService.getDynamicContentByType('general_company');
    if (this.router.url.includes('/configuration/opportunity') ||
      this.router.url.includes('/configuration/email-history') ||
      this.router.url.includes('/configuration/email-inbox') ||
      this.router.url.includes('/configuration/history-data') ||
      this.router.url.includes('/configuration/email-campaign') ||
      this.router.url.includes('/configuration/dashboard-contact-map') ||
      this.router.url.includes('/configuration/sale-convert-history') ||
      this.router.url.includes('/configuration/import-contact') ||
      this.router.url.includes('/configuration/activity-log')
    ) {
      this.isShowButton = true;
    }

    this.settingPoolService.getSettingByKeyAndGroup("IS_USE_NEW_UI_DETAIL", "SYSTEM").subscribe(resp => {
      if (resp?.result) this.useNewUI = parseInt(resp?.result?.value) > 0;
    })
    this.settingPoolService.getSettingByKeyAndGroup("IS_CRM_MODE", "SYSTEM").subscribe(resp => {
      if (resp?.result) {
        this.isCRMMode = resp.result.value.toString();
      }
    })
    // Your existing code...
  }

  ngOnInit(): void {
    window.addEventListener('message', this.handleArtistProposalWindowMessage);
    this.userService.getAllUser();
    this.getBackOfficeURL();
    this.checkAutomationProcess();
    this.loadLocationData();
    
    this.proposalHistoryStore.loadAll$
      .pipe(takeUntil(this.destroy$))
      .subscribe(loadAll => {
        this.inquiryHistoryLoadAll = !!loadAll;
      });
    this.proposalHistoryStore.modalBodyLoading$
      .pipe(takeUntil(this.destroy$))
      .subscribe(isLoading => {
        this.inquiryHistoryBodyLoading = !!isLoading;
      });
    this.proposalHistoryStore.modalBodyError$
      .pipe(takeUntil(this.destroy$))
      .subscribe(hasError => {
        this.inquiryHistoryBodyError = !!hasError;
      });

    if (this.openByDialog && this.dialModalRef?.componentInstance) {
      this.dialModalRef.afterOpened().subscribe(() => {
        var overlayBackdrops = window.document.querySelectorAll<any>('.cdk-overlay-backdrop.cdk-overlay-dark-backdrop.cdk-overlay-backdrop-showing');
        for (var i = 0; i < overlayBackdrops.length; i++)
          overlayBackdrops[i].classList.add('overlay-backdrop-tab-mode');
      })

      this.dialModalRef.updatePosition({ right: '0', bottom: '0' });
      if (this.data.advancedImport) {
        this.dialModalRef.updateSize(this.openByDialog ? '1450px' : '1600px', Helper.heightDialog());
      }
      else {
        this.dialModalRef.updateSize(this.openByDialog ? '1200px' : '1600px', Helper.heightDialog());
      }
    }

    // this.taskService.getAllTaskStatus();
    // this.taskService.getAllPriority();
    // this.taskService.getAllTaskType();
    this.formatCurrencyPrefix();

    // Load contact types for dropdown
    this.getContactType.pipe(takeUntil(this.destroy$)).subscribe((returnData: any[]) => {
      if (returnData) {
        this.allContactTypesAsDropdownModel = returnData.slice().map(x => {
          return new DropDownValue(x.value, x.key.toString(), x.color);
        });
        this.setupContactType();
      }
    });

    this.opportunityService.getOpportunityById()
      .pipe(
        tap(resp => this.profileService._profileDetailData$.next(resp)),
        takeUntil(this.destroy$)
      ).subscribe({
        next: resp => { if (resp.result) this.setupOpportunity(resp.result); },
        complete: () => {
          this.isLoading = false
        },
      });
  }

  ngAfterViewInit(): void {
    this.ensureInquiryWidgetMounted();

    this.accessChecker.isGranted('view', 'total-client-fee')
      .pipe(take(1))
      .subscribe((granted: boolean) => {
        this.isDisableProduct = granted;
      });

    this.overlayNoteDetails = this.noteService.overlayNoteDetailsComponent;
    if (this.router.url.includes('/configuration/opportunity-crm/') || this.router.url.includes('/configuration/opportunity/')) {
      // get cache tab index in local storage:
      let tag = this.getCacheTab();
      let patternRegex = /#([\d]+)/;
      if (!Helper.isNullOrEmpty(tag)) {
        this.selectTab = parseInt(tag.replace('#', ''));
        const sessionURL = this.router.url.includes('/configuration/opportunity-crm/') ? '/configuration/opportunity-crm' : '/configuration/opportunity';
        Helper.handleTabChangedUrl(this.selectTab, sessionURL);
      } else
        // if end with #tabIndex then move to that tab
        if (patternRegex.test(this.router.url)) {
          let matchTabIndex = this.router.url.match(patternRegex).length > 0 ? Number.parseInt(this.router.url.match(patternRegex)[0].replace('#', '')) : TabOpportunity.Artist;
          this.selectTab = matchTabIndex;
        }
    } else {
      // this.selectTab = this.openByDialog ? TabOpportunity.Contact : TabOpportunity.Tasks;
      this.selectTab = TabOpportunity.Artist
    }

    this.opportunityService.isRefreshOpportunityGrid$.asObservable()
      .pipe(takeUntil(this.destroy$))
      .subscribe((isRefresh: boolean) => this.isRefreshing = isRefresh);

    this.overlayNoteDetails.onRefreshed().pipe(
      takeUntil(this.destroy$),
      debounceTime(2000)
    ).subscribe(resp => {
      this.overlayNoteDetails.completedLoading();
      if (resp && this.noteTab) this.noteTab.refreshData();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    const changeId = changes.id;
    const changeTaskId = changes.optionalTaskId;
    if (changeId && changeId.currentValue != changeId.previousValue)
      this.refreshData();

    if (changeTaskId && changeTaskId.currentValue != changeTaskId.previousValue) {
      this.optionalTaskId = changeTaskId.currentValue;
    }
  }

  ngOnDestroy(): void {
    window.removeEventListener('message', this.handleArtistProposalWindowMessage);

    if (this.routeSub != null)
      this.routeSub.unsubscribe();

    if (this.opportunityService.opportunityDetail$)
      this.opportunityService.opportunityDetail$.next(new ReturnResult<any>());
    this.inquiryWidgetHost?.clear();
    this.proposalWidgetOpenSub?.unsubscribe();
    this.proposalWidgetOpenSub = null;
    this.inquiryHistoryRuntime.navigateSub?.unsubscribe();
    this.inquiryHistoryRuntime.navigateSub = null;
    this.shutdownInquiryHistoryWidget();
    this.crmInquiryWidgetRef = null;
    this.proposalHistoryStore.clear();
    this.destroy$.next();
    this.destroy$.complete();
  }

  refreshData() {
    this.opportunityService.refreshOpportunityById(this.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: resp => {
          if (resp.result) {
            this.setupOpportunity(resp.result);
            this.getSumIncomeAndExpense();
            this.getIdLossReason();
            this.lostReasonComponent?.loadCloseLostReasons();
          }
        },
        complete: () => {
          this.isLoading = false;
          this.getOwner();
        },
      });
  }

  parseMathStrToValue(str) {
    return Function(`'use strict'; return (${str})`)()
  }

  get profitPercent(): number {
    var totalValue = this.opportunityModel?.profileAdditionDetail?.totalValue;
    var totalClientFee = this.opportunityModel?.profileAdditionDetail?.totalClientFee;

    if (totalValue && totalClientFee) {
      return parseFloat(((totalValue / totalClientFee) * 100).toFixed(2));
    }
    return 0;
  }

  get profitColor(): string {
    if (this.profitPercent < this.getPercentageProfitSetting) {
        return 'red';
      }
      else {
        return 'green';
      }
  }

  calculateTotalValue(model: ProfileAdditionDetail) {
    this.mathEquation = this.mathEquation.replace('{ARR}', (model?.arr ?? 0).toString())
      .replace('{OneTimeProduct}', (model?.oneTimeProduct ?? 0).toString())
      .replace('{OneTimeService}', (model?.oneTimeService ?? 0).toString())
      .replace('{TermOfContract}', (model?.termOfContract ?? 0).toString());
    if (this.opportunityModel.profileAdditionDetail)
      this.opportunityModel.profileAdditionDetail.totalValue = this.parseMathStrToValue(this.mathEquation);
  }
  async setupTotalNumber() {
    if (this.id) {
      var getTotalNumber = await this.profileAdditionService.getGeneralCountByProfileId(this.id).toPromise();
      if (getTotalNumber.result) {
        this.generalCount = getTotalNumber.result;
        // getTotalNumber.result.forEach(e => {
        //   if (e.typeName == 'TotalFile') {
        //     this.totalFile = e.totalNumber;
        //   } else if (e.typeName == 'TotalTask') {
        //     this.totalTask = e.totalNumber;
        //   }
        // })
      }
    }
  }
  setupOpportunity(data: ProfileDetailModel) {
    if (data) {
      this.opportunityModel = Helper.copyRemoveHeap(data);
      this.setupSaleAccount(data?.saleOpportunity?.opportunityProfile?.profileId);

      // Parse closeDate to literal date value (ignoring timezone conversion)
      if (this.opportunityModel?.saleOpportunity?.closeDate) {
        this.opportunityModel.saleOpportunity.closeDate = Helper.parseDateStringLiteral(
          this.opportunityModel.saleOpportunity.closeDate
        );
      }

      // Parse secondaryCloseDate to literal date value (ignoring timezone conversion)
      if (this.opportunityModel?.saleOpportunity?.secondaryCloseDate) {
        this.opportunityModel.saleOpportunity.secondaryCloseDate = Helper.parseDateStringLiteral(
          this.opportunityModel.saleOpportunity.secondaryCloseDate
        );
      }

      this.setupTotalNumber();
      this.totalContact = this.opportunityModel?.profileAdditionDetail?.totalContact || 0;
      this.lastContact = this.opportunityModel?.profileAdditionDetail?.lastContact || "Never Contacted";

      this.currentStage = this.listStage.find(x =>
        parseInt(x.key) == this.opportunityModel?.automateDataStateId
      ) ?? this.listStage.find(x => x != null);
      if (this.opportunityModel.saleOpportunity)
      {
        this.saleOpportunityEmit.emit(this.opportunityModel.saleOpportunity);
        this.checkCloseDateIsClientTime(this.opportunityModel.saleOpportunity);
      }

      this.isHasPrimaryContact = this.opportunityModel.contact && !this.opportunityModel.contact.deleted ? true : false;
      this.checkStateOpportunity();
      this.bindInquiryWidgetAccountId();
      this.ensureInquiryWidgetMounted();

      this.whiteLabelUrl = this.opportunityModel?.extendData ? JSON.parse(this.opportunityModel?.extendData)["whiteLabelUrl"] : "";
      this.setInlineLostReason?.lostReasonControl?.patchValue(data?.saleOpportunity?.lostReason || '');
    }
  }

  /**
   * Lazily creates summary widget component and wires `openHistory` event bridge.
   * Reuses existing instance when already mounted.
   */
  private async ensureInquiryWidgetMounted(): Promise<void> {
    if (!this.inquiryWidgetHost) {
      return;
    }

    if (this.crmInquiryWidgetRef) {
      this.inquiryWidgetCompositeState.loading = false;
      this.inquiryWidgetCompositeState.loadError = false;
      this.bindInquiryWidgetAccountId();
      return;
    }
    this.inquiryWidgetCompositeState.loading = true;
    this.inquiryWidgetCompositeState.loadError = false;
    try {
      const accountId = this.opportunityModel?.saleOpportunity?.referenceId;
      const mounted = await mountCrmProposalHistoryWidget({
        host: this.inquiryWidgetHost,
        componentFactoryResolver: this.componentFactoryResolver,
        accountId,
        onOpenHistory: () => this.openInquiryHistoryWidget(),
      });
      this.crmInquiryWidgetRef = mounted.ref;
      this.proposalWidgetOpenSub?.unsubscribe();
      this.proposalWidgetOpenSub = mounted.openHistorySub;
      this.bindInquiryWidgetAccountId();
      this.inquiryWidgetCompositeState.loading = false;
    } catch (error) {
      this.inquiryWidgetCompositeState.loading = false;
      this.inquiryWidgetCompositeState.loadError = true;
      console.error('Failed to lazy-load inquiry history widget:', error);
    }
  }

  /**
   * Syncs current opportunity account context into:
   * - proposal-history store query key,
   * - mounted summary widget input (`accountId`).
   */
  private bindInquiryWidgetAccountId(): void {
    const accountId = this.opportunityModel?.saleOpportunity?.referenceId;
    if (accountId) {
      this.proposalHistoryStore.setQuery(accountId).catch(() => this.proposalHistoryStore.clear());
    } else {
      this.proposalHistoryStore.clear();
    }
    if (this.crmInquiryWidgetRef && this.crmInquiryWidgetRef.instance) {
      this.crmInquiryWidgetRef.instance.accountId = accountId;
    }
  }

  checkStateOpportunity() {
    if (this.opportunityModel?.automateDataStateId && this.lostTypeId && this.wonTypeId)
      switch (this.opportunityModel?.automateDataStateId) {
        case this.lostTypeId:
        case this.wonTypeId:
          this.opportunityModel['disabledProbability'] = true;
          this.opportunityModel['tooltipProbability'] = `Can not modify the field because of the ${this.currentStage?.value} state`;
          console.log(this.opportunityModel['tooltipProbability']);
          break;
        default:
          break;
      }
  }

  async editOpportunity(value: any, prop: string, typeModel: TypeEditModelOpportunity = TypeEditModelOpportunity.Opportunity) {
    let callCRMService: boolean = false;
    let oldSaleAccountId: string = "";
    let newSaleAccountId: string = "";

    if (Helper.isSpacesOnly(value)) {
      this.toast.danger("Please input a valid data", 'Invalid Input');
      return;
    }

    if (!prop) {
      this.toast.danger('Failed', "Error");
      return;
    }

    if (prop == 'displayName') this.refreshTask.emit();
    if ((prop == 'probability' || prop == 'amount' || prop == 'oneTimeService'
      || prop == 'oneTimeProduct' || prop == 'aRR' || prop == 'termOfContract'
      || prop == 'totalValue')) {
      value = this.numPipe.transform(value);
    }


    if (prop == 'referenceId') {
      callCRMService = true;
      newSaleAccountId = value;
      oldSaleAccountId = this.opportunityModel.saleOpportunity.referenceId;
    }

    let saleOpportunityProfileModel: ProfileDetailModel;
    let saleOpportunityModel: SaleOpportunity;
    let profileAdditionDetailModel: ProfileAdditionDetailForOpportunity;

    // Get client timezone offset when editing closeDate and convert to UTC
    if (prop == 'closeDate' || prop == 'secondaryCloseDate') {
      let offsetHours = 0;

      const anotherProp = prop == 'closeDate' ? 'secondaryCloseDate' : 'closeDate';
      const anotherValue = this.opportunityModel.saleOpportunity[anotherProp];

      let utcValue = value;
      let anotherUtcValue = anotherValue;

      // Convert closeDate value to UTC
      if (value) {
        const offsetMinutes = this.getTimeOffset(value);
        if (prop == 'closeDate') {
          // Not use in backend but must be passed for validation
          // Convert to hours and invert sign (getTimezoneOffset returns negative for positive offsets)
          offsetHours = -offsetMinutes / 60;
        }
        const localDate = new Date(value);
        utcValue = this.getUTCTime(localDate, offsetMinutes);
      }

      if (anotherValue) {
        const offsetMinutes = this.getTimeOffset(anotherValue);
        if (anotherProp == 'closeDate') {
          // Not use in backend but must be passed for validation
          // Convert to hours and invert sign (getTimezoneOffset returns negative for positive offsets)
          offsetHours = -offsetMinutes / 60;
        }
        const anotherLocalDate = new Date(anotherValue);
        anotherUtcValue = this.getUTCTime(anotherLocalDate, offsetMinutes);
      }

      saleOpportunityProfileModel = Object.assign({}, this.opportunityModel, { [anotherProp]: anotherUtcValue ?? undefined, [prop]: utcValue });
      saleOpportunityModel = Object.assign({}, this.opportunityModel.saleOpportunity, { [anotherProp]: anotherUtcValue ?? undefined, [prop]: utcValue, offsetTime: offsetHours }, { profileParentId: this.id });
      profileAdditionDetailModel = Object.assign({}, this.opportunityModel.profileAdditionDetail, { [anotherProp]: anotherUtcValue ?? undefined, [prop]: utcValue ?? 0 });
    } else {
      // Create copies of the models
      let updatedOpportunityModel = Object.assign({}, this.opportunityModel, { [prop]: value });
      let updatedSaleOpportunityModel = Object.assign({}, this.opportunityModel.saleOpportunity, { [prop]: value }, { profileParentId: this.id });
      let updatedProfileAdditionDetailModel = Object.assign({}, this.opportunityModel.profileAdditionDetail, { [prop]: value ?? 0 });

      // Convert existing closeDate to UTC if it exists
      if (updatedSaleOpportunityModel.closeDate) {
        // Calculate timezone offset by minutes from the closeDate value
        const offsetMinutes = this.getTimeOffset(updatedSaleOpportunityModel.closeDate);
        const offsetHours = -offsetMinutes / 60; // Not use in backend but must be passed for validation
        const localDate = new Date(updatedSaleOpportunityModel.closeDate);
        updatedSaleOpportunityModel.closeDate = this.getUTCTime(localDate, offsetMinutes);
        updatedSaleOpportunityModel.offsetTime = offsetHours;
      }

      // Convert existing secondaryCloseDate to UTC if it exists
      if (updatedSaleOpportunityModel.secondaryCloseDate) {
        const localDate = new Date(updatedSaleOpportunityModel.secondaryCloseDate);
        updatedSaleOpportunityModel.secondaryCloseDate = this.getUTCTime(localDate);
      }

      saleOpportunityProfileModel = updatedOpportunityModel;
      saleOpportunityModel = updatedSaleOpportunityModel;
      profileAdditionDetailModel = updatedProfileAdditionDetailModel;
    }

    this.isLoadingEdit = true;


    if (prop == 'oneTimeService' || prop == 'oneTimeProduct' || prop == 'aRR' || prop == 'termOfContract' || prop == 'totalValue' || prop == 'companySize' || prop == 'maintenanceDate') {
      if (this.opportunityModel && this.opportunityModel.profileAdditionDetail) {
        this.opportunityModel.profileAdditionDetail.totalValue = 0;

        if (prop == "maintenanceDate" && value == null) {
          profileAdditionDetailModel.maintenanceDate = null;
        }
      }
      this.isCalculate = true;
      profileAdditionDetailModel.profileId = this.opportunityModel.profileId;
      this.profileAdditionService.saveSingleProfileAdditionByPropName(prop, profileAdditionDetailModel)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: resp => {
            if (resp.result) {
              if (prop != 'totalValue')
                this.toast.success(`Edit ${this.environment.titleOpportunity} success!`, "Success");
              this.refreshData();
            }
          },
          error: err => this.isLoadingEdit = false,
          complete: () => {
            this.isLoadingEdit = false;
          }
        });

      this.isCalculate = false;
      return;
    }
    const isEnableCoreRemoting = (await this.settingPoolService.getSettingByKeyAndGroup("IS_ENABLE_CORE_REMOTING", "OFFICE_365_SSO").toPromise())?.result?.value.toString();
    this.opportunityService.editOpportunity({
      id: typeModel == TypeEditModelOpportunity.OpportunityProfile
        ? this.opportunityModel.profileId
        : this.opportunityModel.saleOpportunity.saleOpportunityId.toString(),
      saleOpportunityProfileModel: typeModel == TypeEditModelOpportunity.OpportunityProfile
        ? saleOpportunityProfileModel : null,
      saleOpportunityModel: typeModel == TypeEditModelOpportunity.Opportunity
        ? saleOpportunityModel : null,
      opportunityId: this.id
    }).pipe(takeUntil(this.destroy$))
      .subscribe({
        next: resp => {
          if (resp.result) {
            if (prop != 'displayName')
              this.toast.success(`Edit ${this.environment.titleOpportunity} success!`, "Success");
            if (prop == 'opportunityName' && isEnableCoreRemoting != null && parseInt(isEnableCoreRemoting) == 0)
              this.microsoftOffice365Service.updateNameFolder(
                this.opportunityModel?.profileId,
                this.opportunityModel?.typeName,
                this.opportunityModel?.saleOpportunity?.opportunityName,
                value
              ).subscribe();

            if (prop == "ownerId") this.ownerModel = null;

            if (callCRMService && isEnableCoreRemoting != null && parseInt(isEnableCoreRemoting) == 0) {
              this.moveFolderOneDrive(this.id, oldSaleAccountId, newSaleAccountId);
            }
            if (prop === 'lostReason') {
              this.lostReasonComponent.isLoadingCloseLostReason = true;
              this.onCloseLostReasonChange.emit(false);
            }

            if (prop === 'referenceId') {
              this.vendorTab?.refreshData();
            }

            this.refreshData();
          }
        },
        error: err => this.isLoadingEdit = false,
        complete: () => this.isLoadingEdit = false
      });
    this.handleAutomate = false;
  }

  moveFolderOneDrive(opportunityId: string, oldSaleAccountId: string, newSaleAccountId: string) {
    try {
      if (!Helper.isNullOrEmpty(newSaleAccountId)) {
        this.microsoftOffice365Service.moveFolderOneDriveProposal(opportunityId, oldSaleAccountId, newSaleAccountId, true).subscribe(result => {
          if (result && !result.result) {
            this.toast.danger("Can't move folder OneDrive");
          }
        })
      }
      else {
        this.microsoftOffice365Service.moveFolderOneDriveProposal(opportunityId, oldSaleAccountId, newSaleAccountId, false).subscribe(result => {
          if (result && !result.result) {
            this.toast.danger("Can't move folder OneDrive");
          }
        })
      }
    }
    catch (err) {
      console.error(err);
    }
  }

  checkCloseDateIsClientTime(saleOpportunity: SaleOpportunity) {
    if (saleOpportunity.offsetTime != null) {
      this.isShowSwitchEventDateButton = true;
    }
    else {
      this.isShowSwitchEventDateButton = false;
    }
  }

  /**
   * @deprecated This method is deprecated. Time will be parsed in load and save methods.
   */
  switchEventDateFormat() {
    var formatType = this.opportunityModel.saleOpportunity.currentFormatTime == 'client' ? 'server' : 'client';

    this.opportunityService.switchToClientOrServerTime(this.opportunityModel.saleOpportunity.saleOpportunityId, formatType).subscribe(result => {
      if (result?.result) {
        // Parse date string to literal date value (ignoring timezone conversion)
        const closeDateValue = Helper.parseDateStringLiteral(result.result.closedDate);

        // Update model with new values
        this.opportunityModel = {
          ...this.opportunityModel,
          saleOpportunity: {
            ...this.opportunityModel.saleOpportunity,
            currentFormatTime: result.result.currentFormatTime,
            closeDate: closeDateValue
          }
        };

        // Force re-render by toggling input visibility
        this.showCloseDateInput = false;
        setTimeout(() => {
          this.showCloseDateInput = true;
        }, 100);

        this.toast.success(`Switch ${this.environment.titleOpportunity} date format success!`, "Success");
      }
    });
  }

  async closeDialog() {
    if (this.dialModalRef?.componentInstance)
      this.dialModalRef.close(this.isRefreshing);
    this.onClose.emit(this.isRefreshing);

    if (Helper.checkUrlDetailObj('opportunity-crm') || Helper.checkUrlDetailObj('opportunity')) {
      this.isClosing = true;
      try {
        // const urlBack = Helper.popBackURL() || '/configuration/opportunity';
        // this.router.navigate([urlBack]);

        var urlBack = Helper.popBackURL() || `/configuration/opportunity`;
        this.userExperienceTrackingService.navigatePrevious(`/configuration/opportunity`);
      } catch (error) {

      } finally {
        this.isClosing = false;
      }
    }
  }

  copyToClipboard() {
    const url = window.location.href.split('configuration')[0] + `configuration/opportunity-crm/${this.id}`;
    this.clipboard.copy(url);
    this.toast.info(`Copied this ${this.environment.titleOpportunity} url to clipboard`, 'Success');
  }

  sendMailClick(profile: ProfileDetailModel = null) {
    const dialogRef = this.dialog.open(LinkscopeEmailComponent, {
      disableClose: true,
      autoFocus: false,
      data: {
        profileModel: profile ?? this.opportunityModel,
        entity: 'profile',
        optionTaskId: this.optionalTaskId,
        isShowSenderId: true,
        lastSentEmailEntity: this.environment.titleOpportunity
      }
    });

    dialogRef.afterClosed().subscribe(response => {
      if (response != null) {
        // return when closed
      }
    });
  }

  async onClickCall(alternativeContact: Contact = null) {
    this.isCallLoading = true;
    await this.callService.makeACall(
      alternativeContact ?? this.opportunityModel.contact,
      this.opportunityModel.profileContacts,
      this.user.nameid,
      this.opportunityModel.profileId,
      this.creatableTask,
      this.optionalTaskId ? parseInt(this.optionalTaskId) : null,
      this.isCallLoading,
      this.toast,
      this.isCalling,
      'profile'
    );
    setTimeout(() => {
      this.isCallLoading = false;
    }, 3000);
  }

  createTask() {
    // this.dialogRef.componentInstance
    if (!this.crmTaskService.isOpenTask) {
      this.crmTaskService.isOpenTask = true;
      this.crmTaskService.dialogTaskRef = this.dialog.open(AddEditTaskComponent, {
        disableClose: true,
        height: '65vh',
        width: '600px',
        panelClass: 'dialog-detail',
        autoFocus: false,
        hasBackdrop: false,
        data: {
          type: 'customType',
          action: TblActionType.Add,
          profile: this.opportunityModel,
          position: { left: '0', bottom: '0' }
        }
      });
      this.crmTaskService.dialogTaskRef.afterClosed().subscribe(response => {
        if (response) {
          if (this.taskGrid) this.taskGrid.refreshData();
          this.refreshData();
        }
        this.crmTaskService.isOpenTask = false;
      });
    }
    else {
      if (this.crmTaskService.dialogTaskRef.componentInstance.isMinimize)
        this.crmTaskService.dialogTaskRef.componentInstance.minimizeDialog();
    }
    // this.windowService.open(this.createNewTask, {
    //   hasBackdrop: false,
    //   initialState: NbWindowState.MAXIMIZED,
    //   title: "Create New Task",
    //   windowClass: 'custom-create-new-task',
    //   buttons: {
    //     minimize: true,
    //     maximize: true,
    //     fullScreen: false,
    //   }
    // })

    // setTimeout(() => {
    //   var overlayTypeObject = window.document.querySelector<any>(`.custom-create-new-task`);
    //   if (overlayTypeObject) {
    //     overlayTypeObject.closest('.cdk-global-overlay-wrapper').style.justifyContent = "flex-start";
    //   }
    // }, 1)
  }

  createProposalNonArtist(className: string) {
    const dialogRef = this.dialog.open(AddEditProposalNonArtistIncomeComponent, {
      disableClose: true,
      height: '100vh',
      width: '600px',
      panelClass: 'dialog-detail',
      autoFocus: false,
      data: {
        action: TblActionType.Add,
        model: this.proposalNonArtist,
        proposalId: this.opportunityModel.profileId,
        className: className
      }
    });
    dialogRef.afterClosed().subscribe(response => {
      if (response) {
        if (this.proposalNonArtistTab)
          this.proposalNonArtistTab.refreshData();
        this.editOpportunity('', 'totalValue', TypeEditModelOpportunity.Opportunity);
      }
    });
  }
  apiToSearchAccount(input: string) {
    return this.accountService.searchSaleAccount(input);
  }
  saveAccount(data) {
    if (typeof data == 'string') {
      if (data == 'NEW') {
        this.newAccount();
      }
      else {
        this.editSaleAccount(data, "displayName");
      }
      return;
    }

    if (this.opportunityModel.saleOpportunity) {
      this.opportunityModel.saleOpportunity.referenceType = "SALEACCOUNT";
    }

    if (data.profileId != this.saleAccountModel?.profileId) {
      this.editOpportunity(data.profileId, 'referenceId', TypeEditModelOpportunity.Opportunity)
    }
  }

  copyGUIDToClipboard() {
    this.clipboard.copy(this.id);
    this.toast.info(`Copied this ${this.environment.titleOpportunity} ID to clipboard`, 'Success');
    this.isCopy = true;
    setTimeout(() => {
      this.isCopy = false;
    }, 2000);
  }

  updatePrimaryContact(contactLst: Contact[]) {
    if (this.opportunityModel) {
      let primaryContact = contactLst.find(x => x.primaryContact == true);
      this.contacts = contactLst ? contactLst.map((x: any) => x.contact) : this.contacts;
      if (primaryContact) {
        this.opportunityModel.contact = primaryContact;
        this.opportunityModel.contactId = primaryContact.contactId;
        this.opportunityModel.accountContactId = primaryContact.contactId;
        this.isHasPrimaryContact = this.opportunityModel.contact && !this.opportunityModel.contact.deleted ? true : false;
      } else {
        this.opportunityModel.contact = null;
        this.opportunityModel.contactId = null;
        this.opportunityModel.accountContactId = 0;
        this.isHasPrimaryContact = false;
      }
    }
  }
  editStageOpportunity(data) {
    if (!this.handleAutomate) {
      this.editOpportunity(data.key, 'automateDataStateId', TypeEditModelOpportunity.OpportunityProfile)
    }
  }
  handleAutomateDataState(data: boolean) {
    this.handleAutomate = data;
  }
  tabIndexChanged(tabIndex: number) {
    if (this.router.url.includes('configuration/opportunity')) {
      Helper.handleTabChangedUrl(tabIndex, '/configuration/opportunity');
      // this.tabMode.setTagIndexToCurrentTab(tabIndex, this.id);
      this.userExperienceTrackingService.saveTagIndexChangeInUrl(tabIndex);
    }
  }

  /**
   * Checks if this opportunity has been synced to Lovable Proposal App.
   * Only show Contract Vault button if ExtendGUID exists and is valid.
   */
  get isLovableSynced(): boolean {
    const guid = this.opportunityModel?.profileAdditionDetail?.extendGUID
      || (this.opportunityModel as any)?.extendGUID;
    return !!guid && guid !== '00000000-0000-0000-0000-000000000000' && guid.trim().length > 0;
  }

  /**
   * Resolves the Proposal App UUID (ExtendGUID) to open specific proposal contracting hub.
   */
  get proposalExtendGuid(): string {
    return this.opportunityModel?.profileAdditionDetail?.extendGUID
      || (this.opportunityModel as any)?.extendGUID
      || this.id;
  }


  /**
   * Opens the Contracts & Compliance Vault modal hub (Live Iframe + Downloadable Artifacts).
   * @param initialTab 0 = Contract Workspace (Iframe), 1 = Archived Artifacts.
   */
  openContractVaultDialog(initialTab: number = 0): void {
    const targetProposalId = this.proposalExtendGuid || this.id;
    if (!targetProposalId) return;

    openContractVaultDialog(
      this.dialog,
      targetProposalId,
      this.opportunityModel?.displayName || 'Proposal',
      undefined,
      initialTab
    );
  }


  formatCurrencyPrefix() {

    this.prefixCurrency = `<div class="currency-color">${localStorage.getItem("currency") ?? ""}</div>`
  }

  getOwner() {
    if (!this.opportunityModel && Helper.isNullOrEmpty(this.opportunityModel?.ownerId) || Helper.isEmptyOrSpaces(this.opportunityModel?.ownerId))
      this.ownerModel = Object.assign({ fullName: "Unknown" } as UserModel);

    if (!this.ownerModel && this.opportunityModel?.ownerId)
      this.userService.getUserById(this.opportunityModel?.ownerId).pipe(takeUntil(this.destroy$))
        .subscribe(
          resp => {
            if (resp.result) {
              this.ownerModel = resp.result;
              let fullName = `${this.ownerModel.firstName} ${this.ownerModel.lastName}`;
              this.ownerModel.fullName = fullName.trim() ? fullName : "Unknown";
              this.ownerModel.pictureURL = Helper.userURL(this.ownerModel.pictureURL);
            };
          },
          err => this.ownerModel = Object.assign({ fullName: "Unknown" } as UserModel));
  }

  getIdLossReason() {
    // 2022-02-02 ducqm start add
    // this.settingService.getSettingByGroupName("SALE_CONFIG").subscribe(e => {
    //   if (e.result) {
    //     var lostType = e.result.find(x => x.key == "LOST_TYPE_ID")?.value || '';
    //     this.lostTypeId = lostType ? +lostType : 0;

    //     var wonType = e.result.find(x => x.key == "WON_TYPE_ID")?.value || '';
    //     this.wonTypeId = wonType ? +wonType : 0;
    //     this.checkStateOpportunity();
    //   }
    // })
    this.settingPoolService.getSettingByGroupName("SALE_CONFIG").subscribe(e => {
      if (e.result) {
        var lostType = e.result.find(x => x.key == "LOST_TYPE_ID")?.value || '';
        this.lostTypeId = lostType ? +lostType : 0;

        var wonType = e.result.find(x => x.key == "WON_TYPE_ID")?.value || '';
        this.wonTypeId = wonType ? +wonType : 0;

        this.getPercentageProfitSetting = e.result.find(x => x.key == "PERCENTAGE_PROFIT")?.value || 0;
        this.estimatePipelineThreshold = e.result.find(x => x.key == "ESTIMATE_PIPELINE_THRESHOLD")?.value || 0;
        this.checkStateOpportunity();
      }
    })
    // 2022-02-02 ducqm end add
  }
  async addSaleOpportunityFile(fileInputEvent: any) {
    this.uploading = true;
    this.uploadedFile = fileInputEvent.target.files[0];
    let acceptanceExtension = ["doc", "docx", "xls", "xlsx", "ppt", "pdf", "html", "zip", "csv", "txt"];
    let extension = Helper.getFileExtension(fileInputEvent.target.files[0].name) ? Helper.getFileExtension(fileInputEvent.target.files[0].name)[0] : null;
    // let IsAccept = extension ? (acceptanceExtension.indexOf(extension) == -1 ? false : true) : false;
    let IsAccept = true; // Accept all extensions
    if (IsAccept) {
      let submitModel = new UserUpload();
      submitModel.fileName = this.uploadedFile.name;
      submitModel.referenceType = this.opportunityModel.typeName;
      submitModel.referenceId = this.opportunityModel.profileId;
      submitModel.owners = this.user.nameid;

      var toastRef = this.hotToast.loading('Uploading file...', { autoClose: false });
      try {
        const isEnableCoreRemoting = (await this.settingPoolService.getSettingByKeyAndGroup("IS_ENABLE_CORE_REMOTING", "OFFICE_365_SSO").toPromise())?.result?.value.toString();
        const uploadFile = await this.userUploadService.uploadFile(this.uploadedFile, submitModel).toPromise();
        if (uploadFile?.result) {
          this.fileTab?.refreshData(true);
          this.setupTotalNumber();
          toastRef.close();
          if (isEnableCoreRemoting != null && parseInt(isEnableCoreRemoting) == 0) {
            toastRef = this.hotToast.loading('The attachment is waiting to be uploaded to OneDrive', { duration: 2000 });
            try {
              // submitModel.userUploadId = uploadFile.result?.[0]?.userUploadId;
              // submitModel.fileName = uploadFile.result?.[0]?.fileName;
              // const syncFile = await this.microsoftOffice365Service.uploadFileOffice(this.uploadedFile, submitModel).toPromise();
              const userUploadId = uploadFile.result?.[0]?.userUploadId;
              this.microsoftOffice365Service.uploadFileOneDrive(userUploadId).subscribe(res => {
                if (res.result) {
                  this.hotToast.success('The attachment is successfully added to queue for uploading to OneDrive', { duration: 2000 });
                  toastRef.close();
                }
              });
            }
            catch (ex) {
              toastRef.close();
              this.hotToast.error('An error occurred while syncing...', { duration: 2000 });
            }
          }
          else {
            this.hotToast.success('The attachment is successfully added to queue for uploading to OneDrive', { duration: 2000 });
          }
        }
        else {
          toastRef.close();
        }
      }
      catch (ex) {
        console.log(ex);
        toastRef.close();
        this.hotToast.error('An error occurred while uploading...', { duration: 2000 });
      }
    } else {
      this.toast.warning('Please select file with these extensions: doc,docx,xls,xlsx,ppt,pdf,html,zip,csv,txt', "Warning");
    }
    this.nbFilesPopover.hide();
  }
  getSelectedContactMail(contact: Contact) {
    if (contact) {
      let newProfileModel = Object.assign(this.opportunityModel, {});
      newProfileModel.contact = contact;
      // select other contact:
      this.sendMailClick(newProfileModel);
    } else {
      // skip mode (select primary contact)
      this.sendMailClick(null);
    }
  }
  getSelectedContactCall(contact: Contact) {
    if (contact) {
      let newProfileModel = Object.assign(this.opportunityModel, {});
      newProfileModel.contact = contact;
      // select other contact:
      this.onClickCall(newProfileModel.contact);
    } else {
      // skip mode (select primary contact)
      this.onClickCall(null);
    }
  }
  get checkNumberOfContact() {
    return this.opportunityModel?.profileContacts?.length ?? 0;
  }
  confirmSendMailClick() {
    let convertContact;
    if ((this.opportunityModel?.contact as any)?.contact != null) {
      convertContact = (this.opportunityModel?.contact as any).contact;
    } else {
      convertContact = this.opportunityModel.contact;
    }
    this.opportunityModel.contact = convertContact;
    let confirmClick = this.dialog.open(ConfirmModalComponent, {
      data: {
        message: `Do you wish to send email to ${Helper.getEmailFromContact(convertContact) ?? 'Unknown'} ?`
      }
    });
    confirmClick.afterClosed().subscribe(res => {
      if (res) {
        this.sendMailClick();
      }
    });
  }
  confirmMakeACall() {
    let convertContact;
    if ((this.opportunityModel?.contact as any)?.contact != null) {
      convertContact = (this.opportunityModel?.contact as any).contact;
    } else {
      convertContact = this.opportunityModel.contact;
    }
    this.opportunityModel.contact = convertContact;
    let confirmClick = this.dialog.open(ConfirmModalComponent, {
      data: {
        message: `Do you wish to make a call to number ${Helper.getPhoneFromContact(convertContact) ?? 'Unknown'} ?`
      }
    });
    confirmClick.afterClosed().subscribe(res => {
      if (res) {
        this.onClickCall();
      }
    });
  }
  createContactCampaign() {
    if (!this.contactTab) {
      this.toast.warning('Please select to contact tab to start creating campaign');
      return;
    }
    const dialogRef1 = this.dialog.open(ConfirmModalComponent, {
      data: {
        message: `Do you wish to create campaign with ${this.numberPipe.transform((this.contactTab?.primasTable.selected && this.contactTab?.primasTable.selected.length != 0) ? this.contactTab?.primasTable.selected.length : this.contactTab?.primasTable.table.rowCount)} item(s)?`
      }
    });
    dialogRef1.afterClosed().subscribe(response => {
      if (response) {
        const campaignData: ContactPage = Object.assign({}, this.contactTab.primasTable.page, { relationshipId: this.opportunityModel.profileId, type: "Profile" });
        const ComponentOpen: any = ReviewContactCampaignComponent

        const dialogRef = this.dialog.open(ComponentOpen, {
          width: '1300px',
          disableClose: true,
          autoFocus: false,
          data: {
            contactPage: campaignData,
            isSelectAll: true,
            externalComponent: true,
          }
        });
        dialogRef.afterClosed().subscribe(e => {
          this.refreshData();
          this.contactTab.primasTable.selected = [];
        });
      }
    });
  }
  getCacheTab() {
    // let currentTabMode = this.tabMode.getCurrentActiveTab();
    // let tag: string = null;
    // if (currentTabMode) {
    //   let tabTagIndex: TabTagIndexModel = this.tabMode.getTabTagIndex(currentTabMode.tabId);
    //   if (tabTagIndex && tabTagIndex.uniqueId && typeof tabTagIndex.uniqueId == 'string' && tabTagIndex.uniqueId == this.id) {
    //     tag = tabTagIndex.tag;
    //   }
    // }
    let tag: string = this.userExperienceTrackingService.getTagIndexInUrl();
    return tag;
  }

  async onClickAdvanceImport(action: string) {
    if (action == "Skip") {
      const dialogConfirm = this.dialog.open(ConfirmModalComponent, {
        data: {
          message: `Do you wish to skip 1 item(s)?`
        }, disableClose: true,
      })
      const result = await dialogConfirm.afterClosed().toPromise();
      if (result) {
        this.onAdvancedImport.emit(action);
        this.dialModalRef.close();
      }
    }
    else
      this.onAdvancedImport.emit(action);
  }

  openSMS(contact: Contact) {
    if (contact) {
      const dialogSMS = this.dialog.open(PrimasSendSMSComponent, {
        autoFocus: false,
        disableClose: true,
        panelClass: 'custom-dialog-SMS',
        data: {
          id: this.id,
          referenceType: 'OPPORTUNITY',
          outboundPhone: contact.contactPhone,
        },
      })
    }
  }

  getSumIncomeAndExpense() {
    if (this.id) {
      this.profileAdditionService.sumIncomeAndExpense(this.id).subscribe({
        next: resp => {
          if (resp.result) {
            if (!this.opportunityModel?.profileAdditionDetail)
              this.opportunityModel.profileAdditionDetail = new ProfileAdditionDetail();

            if (this.opportunityModel?.profileAdditionDetail) {
              this.opportunityModel.profileAdditionDetail.nonArtistIncome = (+resp.result["INCOME"]) || 0;
              this.opportunityModel.profileAdditionDetail.nonArtistExpense = (+resp.result["EXPENSES"]) || 0;
            }
          }
        },
      })
    }
  }

  newAccount() {
    const dialogRef = this.dialog.open(AddSaleAccountComponent, {
      disableClose: true,
      height: '100vh',
      width: '600px',
      panelClass: 'dialog-detail',
      autoFocus: false,
      data: {
        action: TblActionType.Add,
      }
    });

    dialogRef.afterClosed().subscribe(response => {
      if (response != null) this.saveAccount({ profileId: response });
    });
  }

  addArtistToProposal() {
    const dialogRef = this.dialog.open(AddEditArtistComponent, {
      disableClose: true,
      height: '100vh',
      width: '600px',
      panelClass: 'dialog-detail',
      autoFocus: false,
      data: {
        action: TblActionType.Add,
        model: { proposalId: this.id }
      }
    });

    dialogRef.afterClosed().subscribe(response => {
      if (response != null) {
        if (this.artistTab?.primasTable)
          typeof response == "boolean"
            ? this.artistTab.primasTable.refreshTable(response)
            : this.artistTab.primasTable.refreshTable();

        this.editOpportunity('', 'totalValue', TypeEditModelOpportunity.Opportunity);
      }
    });
  }

  async proposalArtistTemplate() {
    try {
      this.isCheckingProposalPrevision = true;
      var revisionCur: ProposalRevision;
      var isWhiteLabel: boolean = false;
      var resProposal = await this.opportunityService.getProposalRevisionById(this.id).toPromise();
      if (resProposal.result) revisionCur = resProposal.result;
      var content: {} = revisionCur?.content ? JSON.parse(revisionCur.content) : null;

      if (!content) {
        await this.getWhiteLabelSettingData();
        const confirmDialog = this.dialog.open(ConfirmModalComponent, {
          disableClose: true,
          autoFocus: false,
          width: '400px',
          data: {
            message: '<h6>Setup proposal template</h6>',
            externalTemplate: this.whiteLabelConfirmation,
            yesTitle: 'Ok',
            falseTitle: 'Cancel'
          }
        });
        const confirmResult = await confirmDialog.afterClosed().toPromise();
        if (!confirmResult) return this.isCheckingProposalPrevision = false;
        if (confirmResult) {
          isWhiteLabel = this.proposalOption == "White-Label" ? true : false;
          await this.updateExtendData();
        }
      }
      else {
        isWhiteLabel = revisionCur['isWhiteLabel'] ?? false;
      }
      this.isCheckingProposalPrevision = false;

      const dialog = this.dialog.open(ProposalArtistTemplateComponent, {
        autoFocus: false,
        disableClose: true,
        panelClass: 'custom-proposal',
        data: { id: this.id, isWhiteLabel: isWhiteLabel }
      });

      const closeResult = await dialog.afterClosed().toPromise();
      if (this.proposalRevision)
        this.proposalRevision.refreshData(closeResult);
    } catch (error) {
      console.error(error);
    }

  }

  async openAiOptimize() {
    if (this.isAiOptimizeLoading || !this.isEnableAutomation) return;

    if (!this.opportunityModel?.profileId) {
      this.toast.danger("Opportunity ID not found or empty");
      return;
    }

    try {
      this.isAiOptimizeLoading = true;

      const apiKeyResp = await this.userService.getAPIToken(this.user.nameid).toPromise();
      let apiKey = apiKeyResp?.result;
      if (!apiKey) {
        this.toast.danger(apiKeyResp?.message || "API Token not found or empty, please go to Profile Settings to generate one.");
        this.isAiOptimizeLoading = false;
        return;
      }

      const settingResp = await this.settingPoolService.getSettingByKeyAndGroup("AUTOMATION_PROFILE_PROPOSAL_SUGGESTS", "AUTOMATION").toPromise();
      const frontendUrl = settingResp?.result?.value?.trim();
      if (!frontendUrl) {
        this.toast.danger(settingResp?.message || 'AUTOMATION_PROFILE_PROPOSAL_SUGGESTS setting not found or empty');
        this.isAiOptimizeLoading = false;
        return;
      }

      let parsedUrl: URL;
      try {
        parsedUrl = new URL(frontendUrl);
      } catch {
        this.toast.danger('AUTOMATION_PROFILE_PROPOSAL_SUGGESTS is invalid URL');
        this.isAiOptimizeLoading = false;
        return;
      }
      this.artistProposalAllowedOrigin = parsedUrl.origin;

      this.isAiOptimizeLoading = false;

      this.automationDialogRef = this.dialog.open(AutomationScreenComponent, {
        data: {
          frontend_url: parsedUrl.toString(),
          params: [
            { key: 'bof_token', value: apiKey },
            { key: 'budget', value: String((this.opportunityModel?.saleOpportunity?.amount ?? 0) - ((this.opportunityModel.profileAdditionDetail?.totalClientFee) ? this.opportunityModel.profileAdditionDetail?.totalClientFee : 0)) },
            { key: 'types', value: String(this.opportunityModel?.saleOpportunity?.type ?? '') },
          ]
        },
        disableClose: true,
        autoFocus: false,
        width: '95vw',
        height: '95vh',
        panelClass: 'ai-optimize-dialog'
      });

      const result = await this.automationDialogRef.afterClosed().toPromise();
      this.automationDialogRef = null;
      if (result != null) {
        if (this.artistTab?.primasTable)
          typeof result == "boolean"
            ? this.artistTab.primasTable.refreshTable(result)
            : this.artistTab.primasTable.refreshTable();

        this.editOpportunity('', 'totalValue', TypeEditModelOpportunity.Opportunity);
      }
    }
    catch (error) {
      console.log(error);
      this.toast.danger("Failed to AI Optimize", "Error");
      this.isAiOptimizeLoading = false;
    }
  }

  async checkAutomationProcess() {
    const resp = await this.settingPoolService.getSettingByKeyAndGroup("ENABLE_AUTOMATION_PROCESS", "AUTOMATION").toPromise();
    this.isEnableAutomation = resp.result?.value === "1" || resp.result?.value?.toLowerCase() === "true";
  }

  getBackOfficeURL() {
    this.settingPoolService.getSettingByKeyAndGroup("BACK-OFFICE", "DOMAIN").subscribe(resp => {
      if (resp.result && resp.result.value) this.backOfficeUrl = resp.result.value;
    });
  }
  async copyPublicURLProposal() {
    await this.getWhiteLabelURLData();
    const confirm = this.dialog.open(ConfirmModalComponent, {
      autoFocus: false,
      disableClose: true,
      width: '700px',
      data: {
        message: 'Please note: This is a published proposal link. When you open this URL, we will track your activity in the activity log. If you only wish to view this proposal, please use the preview feature provided by the preview button next to it.',
        externalTemplate: this.copyExternalProposalUrl,
        yesTitle: "Ok",
        falseTitle: "Cancel"
      }
    });
  }

  nbPopoverCLick() {
    this.nbFilesPopover.show();
  }
  openURLDialogRef() {
    const dialogRef = this.dialog.open(UploadUrlComponent, {
      width: '30vw',
      maxWidth: '30vw',
      data: {
        profileId: this.opportunityModel.profileId,
        nameId: this.user.nameid,
        referenceType: "OPPORTUNITY"
      }
    });
    dialogRef.afterClosed().subscribe(resp => {
      if (resp) {
        this.fileTab?.refreshData(true);
        this.setupTotalNumber();
      }
    });
  }


  async refreshTaskTab() {
    if (this.taskGrid) this.taskGrid.refreshData();
    // this.refreshTotalNumberData(this.refreshTotalValueType.task);
    this.setupTotalNumber();
  }

  async refreshNoteTab() {
    if (this.noteTab) this.noteTab.refreshData();
  }

  refreshActivityLog() {
    if (this.activityLogTimeline) {
      this.activityLogTimeline.clickRefresh();
    }
  }

  onStartCall(isNewCall: boolean = false) {
    this.isOnTheCall = true;
    if (isNewCall) this.isUserClosePopNote = false
    this.openNoteCall();
  }

  async onEndCall() {
    this.isOnTheCall = false;
    this.isUserClosePopNote = false;

    await this.updateLastContact();
  }

  async updateLastContact() {
    this.isLoadingLastContact = true;
    try {
      let result = await this.opportunityService.refreshOpportunityById(this.id).toPromise();
      if (result != null && result?.result != null) {
        this.lastContact = result?.result?.profileAdditionDetail?.lastContact || "Never Contacted";
      }
    }
    catch (err) {
      console.error(err);
    }
    finally {
      this.isLoadingLastContact = false;
    }
  }

  // onCloseNote() {
  //   if (this.isOpenCallNote) {
  //     this.dialogCallNote.close();
  //   }
  // }

  openNoteCall() {
    if (!this.isOpenCallNote && !this.isUserClosePopNote) {
      this.isOpenCallNote = !this.isOpenCallNote;
      this.changeDisplayRightColumn();
      this.dialogCallNote = this.dialog.open(DragBlockScreenComponent, {
        hasBackdrop: false,
        data: {
          ngTemplateOutlet: this.noteCard,
          ngTemplateOutletContext: {
            isNoteRow: true,
            isNewNoteFE: true,
          },
          ngTemplateHeaderOutlet: this.headerCallDialog,
          ngTemplateHeaderOutletContext: {
            statusCallModel: this.statusCallComponent?.phoneCallModel,
          },
          onNoteInlineChanged: this.onNoteInlineChanged
        }
      });

      this.dialogCallNote.afterClosed().subscribe(() => {
        this.isOpenCallNote = !this.isOpenCallNote;
        this.changeDisplayRightColumn();
        if (this.isOnTheCall) {
          this.isUserClosePopNote = true;
          this.statusCallComponent.displayCallControl(true);
        }
      });
    }

    if (this.isOpenCallNote)
      this.statusCallComponent.displayCallControl(false);
  }

  refreshTotalNumberData(type: string = null) {
    if (type) {
      if (type == this.refreshTotalValueType.task) {
        if (!this.taskGrid) {
          this.opportunityService.refreshOpportunityById(this.id)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: resp => {
                if (resp.result) {
                  let oppo = resp.result;
                  this.totalContact = (+oppo?.profileAdditionDetail?.totalContact) || 0;
                  this.totalTask = (+oppo?.profileAdditionDetail?.totalTask) || 0;
                }
              },
            });
        }
        else {
          this.totalTask = this.taskGrid?.primasTable?.page?.totalElements || 0;
        }
      }
      else if (type == this.refreshTotalValueType.contact) {
        this.totalContact = this.contactTab?.primasTable?.page?.totalElements || 0;
      }
    } else {
      this.totalContact = this.contactTab?.primasTable?.page?.totalElements || 0;
      this.totalTask = this.taskGrid?.primasTable?.page?.totalElements || 0;
    }
  }

  changeDisplayRightColumn() {
    try {
      let rightComponent = this.noteContainerElement;
      if (this.isOpenCallNote && this.lostTypeId != this.opportunityModel.automateDataStateId) {
        rightComponent.style.display = "none";
      }
      else {
        rightComponent.style.display = "flex";
      }
    }
    catch (ex) {
      console.error(ex);
    }
  }
  openWishList() {
    const url = `${environment.host}/InteractiveProposal/WishList/${this.id}`;
    window.open(url, "blank")
  }

  openRelationshipAccount: () => void = () => {
    var saleAccountId: string = this.opportunityModel?.saleOpportunity?.opportunityProfile?.profileId;
    if (saleAccountId) {
      let relationship = 'sale-account'
      relationship = Helper.getRelationshipURL(this.useNewUI, relationship)
      Helper.pushBackURL();
      Helper.circleDetail(saleAccountId, relationship, null, this.router, this.userExperienceTrackingService);
    }
  }

  /**
   * Opens full history modal and lazily loads heavy table component chunk.
   * Called directly from UI or emitted by summary widget (`openHistory`).
   */
  async openInquiryHistoryWidget(event?: MouseEvent): Promise<void> {
    if (event) {
      event.stopPropagation();
    }
    if (!this.inquiryHistoryDialog) {
      return;
    }
    if (this.inquiryHistoryModalFacade.isOpen()) {
      this.restoreInquiryHistoryWidget();
      if (!this.inquiryHistoryRuntime.shellRef) {
        await this.ensureInquiryHistoryShellComponent();
      }
      if (!this.inquiryHistoryRuntime.gridRef) {
        this.proposalHistoryStore.beginGridMount();
        this.syncInquiryHistoryShellState();
        this.renderInquiryHistoryGridComponent();
      }
      return;
    }

    this.showInquiryHistoryWidget = true;
    this.isInquiryHistoryWidgetMinimized = false;
    this.proposalHistoryStore.resetGridMountState();
    this.proposalHistoryStore.beginGridMount();
    this.syncInquiryHistoryShellState();
    const dialogRef = this.dialog.open(this.inquiryHistoryDialog, {
      width: '92vw',
      maxWidth: '1200px',
      panelClass: 'proposal-history-dialog-panel',
      disableClose: true,
      autoFocus: false,
      restoreFocus: false,
    });
    this.inquiryHistoryModalFacade.setDialogRef(dialogRef);
    this.captureInquiryHistoryBackdrop();
    dialogRef.afterClosed().pipe(take(1)).subscribe(() => this.resetInquiryHistoryRuntimeState());

    await this.ensureInquiryHistoryShellComponent();
    if (this.inquiryHistoryRuntime.shellRef) {
      this.renderInquiryHistoryGridComponent();
    }
  }

  /** Default header close keeps the modal mounted by minimizing it. */
  closeInquiryHistoryWidget(): void {
    if (!this.inquiryHistoryModalFacade.isOpen()) {
      return;
    }
    this.minimizeInquiryHistoryWidget();
  }

  /** Header refresh button: request fresh list data from page 1. */
  reloadInquiryHistoryGrid(): void {
    if (this.isLoadingInquiryHistoryWidget || !this.inquiryHistoryRuntime.gridRef?.instance?.reloadGridData) {
      return;
    }
    this.inquiryHistoryRuntime.gridRef.instance.reloadGridData();
  }

  onToggleLoadAllInquiryHistory(checked: boolean): void {
    const nextValue = !!checked;
    this.proposalHistoryStore.setLoadAll(nextValue);
    this.syncInquiryHistoryShellState();
    this.inquiryHistoryRuntime.gridRef?.instance?.setLoadAllMode?.(nextValue);
    const total = Number(this.proposalHistoryStore?.data?.total || 0);
    if (nextValue && total > CrmOpportunityDetailsComponent.LOAD_ALL_WARNING_THRESHOLD) {
      this.dialog.open(ConfirmModalComponent, {
        data: {
          message: `This will show all ${this.titleOpportunity.toLowerCase()} history items (${total}) and may take a little longer to load.`,
        },
      });
    }
  }

  /** Retry first-load mount when list rendering failed. */
  async retryInquiryHistoryGridLoad(): Promise<void> {
    if (!this.inquiryHistoryModalFacade.isOpen() || this.isLoadingInquiryHistoryWidget) {
      return;
    }
    this.proposalHistoryStore.resetGridMountState();
    this.syncInquiryHistoryShellState();
    try {
      await this.ensureInquiryHistoryShellComponent();
      this.renderInquiryHistoryGridComponent();
    } catch (error) {
      this.proposalHistoryStore.failGridMount();
      this.syncInquiryHistoryShellState();
      console.error('Unable to retry history list load:', error);
    }
  }

  /** Full shutdown used when parent component is destroyed or navigates away. */
  private shutdownInquiryHistoryWidget(): void {
    const dialogRef = this.inquiryHistoryModalFacade.getDialogRef();
    if (!dialogRef) {
      return;
    }
    // Reset visual state so next open always starts clean.
    this.isInquiryHistoryWidgetMinimized = false;
    this.syncInquiryHistoryShellState();
    dialogRef.removePanelClass('proposal-history-dialog-panel-minimized');
    this.setInquiryHistoryBackdropMinimized(false);
    dialogRef.close();
  }

  /** Render (or rebind) the lazy history grid inside modal host. */
  private renderInquiryHistoryGridComponent(): void {
    if (!this.inquiryHistoryModalFacade.isOpen()) {
      return;
    }
    this.syncInquiryHistoryShellState();

    if (this.inquiryHistoryRuntime.gridRef?.instance) {
      this.inquiryHistoryRuntime.gridRef.instance.accountId = this.opportunityModel?.saleOpportunity?.referenceId;
      this.inquiryHistoryRuntime.gridRef.instance.maxHeight = '50vh';
      this.inquiryHistoryRuntime.gridRef.instance.setLoadAllMode?.(this.isLoadAllInquiryHistory);
      this.syncInquiryHistoryShellState();
      return;
    }

    if (this.inquiryHistoryRenderScheduled) {
      return;
    }

    this.inquiryHistoryRenderScheduled = true;
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        this.ngZone.run(() => {
          this.inquiryHistoryRenderScheduled = false;
          const inquiryHistoryHost = (this.inquiryHistoryRuntime.shellRef?.instance as any)?.contentHost as ViewContainerRef | undefined;
          if (!this.inquiryHistoryModalFacade.isOpen() || !inquiryHistoryHost || this.inquiryHistoryRuntime.gridRef) {
            this.syncInquiryHistoryShellState();
            return;
          }

          mountProposalHistoryGrid({
            host: inquiryHistoryHost,
            componentFactoryResolver: this.componentFactoryResolver,
            accountId: this.opportunityModel?.saleOpportunity?.referenceId,
            maxHeight: '50vh',
            loadAll: this.isLoadAllInquiryHistory,
            onMountStart: () => this.proposalHistoryStore.beginGridMount(),
            onMountSuccess: () => this.proposalHistoryStore.completeGridMount(),
            onMountError: () => this.proposalHistoryStore.failGridMount(),
          }).then(ref => {
            this.inquiryHistoryRuntime.gridRef = ref;
            this.inquiryHistoryRuntime.navigateSub?.unsubscribe();
            this.inquiryHistoryRuntime.navigateSub = this.inquiryHistoryRuntime.gridRef.instance.navigateFromGrid?.subscribe?.(() => {
              // Delay minimize by one tick to avoid Angular change-detection timing issues.
              setTimeout(() => this.closeInquiryHistoryWidget());
            }) || null;
            this.changeDetectorRef.detectChanges();
          }).catch((error) => {
            this.proposalHistoryStore.failGridMount();
            console.error('Unable to render history list component:', error);
          }).finally(() => {
            this.syncInquiryHistoryShellState();
          });
        });
      });
    });
  }

  private minimizeInquiryHistoryWidget(): void {
    const dialogRef = this.inquiryHistoryModalFacade.getDialogRef();
    if (!dialogRef) {
      return;
    }
    this.inquiryHistoryRuntime.gridRef?.instance?.reloadGridDataIfNotFirstPage?.();
    const anchorRect = this.inquiryWidgetAnchor?.nativeElement?.getBoundingClientRect();
    this.isInquiryHistoryWidgetMinimized = true;
    this.syncInquiryHistoryShellState();
    dialogRef.addPanelClass('proposal-history-dialog-panel-minimized');
    dialogRef.updateSize(anchorRect?.width ? `${Math.max(anchorRect.width, 320)}px` : '360px', '');
    dialogRef.updatePosition(
      anchorRect
        ? { left: `${Math.max(anchorRect.left, 8)}px`, top: `${Math.max(anchorRect.top, 8)}px` }
        : { right: '16px', bottom: '16px' },
    );
    this.setInquiryHistoryBackdropMinimized(true);
  }

  private restoreInquiryHistoryWidget(): void {
    const dialogRef = this.inquiryHistoryModalFacade.getDialogRef();
    if (!dialogRef) {
      return;
    }
    this.isInquiryHistoryWidgetMinimized = false;
    this.syncInquiryHistoryShellState();
    dialogRef.removePanelClass('proposal-history-dialog-panel-minimized');
    dialogRef.updateSize('92vw', '');
    dialogRef.updatePosition({ right: '', bottom: '' });
    this.setInquiryHistoryBackdropMinimized(false);
    this.inquiryHistoryRuntime.gridRef?.instance?.recalculateGridLayout?.();
  }

  private captureInquiryHistoryBackdrop(): void {
    const overlayRef = (this.inquiryHistoryModalFacade.getDialogRef() as any)?._overlayRef;
    this.inquiryHistoryModalFacade.setBackdropElement((overlayRef?.backdropElement as HTMLElement) || null);
  }

  private setInquiryHistoryBackdropMinimized(minimized: boolean): void {
    const backdropEl = this.inquiryHistoryModalFacade.getBackdropElement();
    if (!backdropEl) {
      return;
    }
    backdropEl.style.opacity = minimized ? '0' : '';
    backdropEl.style.pointerEvents = minimized ? 'none' : '';
  }

  private async ensureInquiryHistoryShellComponent(): Promise<void> {
    if (!this.inquiryHistoryModalFacade.isOpen()) {
      return;
    }
    if (!this.inquiryHistoryShellHost) {
      // Dialog template host is not always ready immediately after open().
      setTimeout(async () => {
        if (!this.inquiryHistoryRuntime.shellRef && this.inquiryHistoryModalFacade.isOpen()) {
          await this.ensureInquiryHistoryShellComponent();
          if (this.inquiryHistoryRuntime.shellRef && !this.inquiryHistoryRuntime.gridRef) {
            this.renderInquiryHistoryGridComponent();
          }
        }
      }, 0);
      return;
    }
    if (this.inquiryHistoryRuntime.shellRef) {
      this.syncInquiryHistoryShellState();
      return;
    }
    const mounted = await mountProposalHistoryModalShell({
      host: this.inquiryHistoryShellHost,
      componentFactoryResolver: this.componentFactoryResolver,
      onLoadAll: (checked: boolean) => this.onToggleLoadAllInquiryHistory(checked),
      onReload: () => this.reloadInquiryHistoryGrid(),
      onClose: () => this.closeInquiryHistoryWidget(),
      onRetry: () => this.retryInquiryHistoryGridLoad(),
    });
    this.inquiryHistoryRuntime.shellRef = mounted.ref;
    this.inquiryHistoryRuntime.shellBindings = mounted.bindings;

    this.syncInquiryHistoryShellState();
    this.changeDetectorRef.detectChanges();
  }

  private syncInquiryHistoryShellState(): void {
    syncProposalHistoryModalShellState(this.inquiryHistoryRuntime.shellRef, {
      title: `${this.titleOpportunity} History`,
      isMinimized: this.isInquiryHistoryWidgetMinimized,
      isLoading: this.isLoadingInquiryHistoryWidget,
      hasRenderedContent: !!this.inquiryHistoryRuntime.gridRef,
      hasLoadError: this.hasInquiryHistoryGridLoadError,
      loadAllChecked: this.isLoadAllInquiryHistory,
      skeletonCount: 6,
      errorMessage: 'We could not load the history list.',
      showRetry: true,
    });
  }

  private unbindInquiryHistoryShellBindings(): void {
    this.inquiryHistoryRuntime.shellBindings = disposeProposalHistoryModalShellBindings(this.inquiryHistoryRuntime.shellBindings);
  }

  private resetInquiryHistoryRuntimeState(): void {
    this.showInquiryHistoryWidget = false;
    this.inquiryHistoryShellHost?.clear();
    this.unbindInquiryHistoryShellBindings();
    this.inquiryHistoryRuntime.navigateSub?.unsubscribe();
    this.inquiryHistoryRuntime.navigateSub = null;
    this.inquiryHistoryRuntime.gridRef = null;
    this.inquiryHistoryRuntime.shellRef = null;
    this.inquiryHistoryModalFacade.clear();
    this.proposalHistoryStore.resetGridMountState();
  }
  async getWhiteLabelSettingData() {
    try {
      const result = await this.settingPoolService.getSettingByKeyAndGroup("WHITE_LABEL_URL", "INTERACTIVE_PROPOSAL").toPromise();
      if (result.result) {
        this.rootWhiteLabelUrl = result.result?.value;
      }
    }
    catch (ex) {

    }
  }
  async updateExtendData() {
    this.whiteLabelUrl = this.whiteLabelUrl?.trim().split(" ").filter(x => x).join("-");
    const proposalWhiteLabelData = {
      proposalId: this.id,
      whiteLabelUrl: this.whiteLabelUrl,
    } as ProposalWhiteLabelData
    const result = await this.opportunityService.updateWhiteLabelUrl(proposalWhiteLabelData).toPromise();
  }
  async getWhiteLabelURLData() {
    this.getWhiteLabelLoading = true;
    try {
      const result = await this.opportunityService.getProposalWhiteLabelData(this.id).toPromise();
      if (result.result) {
        this.proposalWhiteLabelData = result.result;
      }
    }
    catch (ex) {
    }
    this.getWhiteLabelLoading = false;
  }

  copyWhiteLabelUrl(mode: string) {
    const url = mode == "Default" ? `${this.backOfficeUrl}proposal-views/${this.id}` :
      `https://${this.proposalWhiteLabelData.whiteLabelUrl}.${this.proposalWhiteLabelData.rootWhiteLabelUrl}/proposal-views/${this.id}`;
    this.clipboard.copy(url);
    this.toast.info(`Copied to clipboard successfully`, 'Success');
  }

  async openOneDriveFolderUrl() {
    var toastRef = this.hotToast.loading('Redirecting to Microsoft OneDrive folder of this Proposal...', { autoClose: false });
    try {
      const getOneDriveFolderData = await this.microsoftOffice365Service.getOneDriveFolderData(this.id, 'OPPORTUNITY').toPromise();
      if (getOneDriveFolderData.result) {
        this.handleAuthorizeOpenFolderUrl(getOneDriveFolderData.result.id, getOneDriveFolderData.result.webUrl, toastRef);
      }
      else {
        this.poolingCheckOneDriveDataByProfileId(this.id, toastRef);
      }
    } catch (error) {
      console.log(error);
      toastRef.close();
      this.hotToast.error('An error occurred while opening OneDrive folder url...', { duration: 2000 });
    }
  }
  poolingCheckOneDriveDataByProfileId(profileId: string, toastRef: any) {
    if (this.isDoingCheckingOneDriveData) {
      return;
    }
    try {
      this.isDoingCheckingOneDriveData = true;
      const source = timer(0, 3000);
      if (this.checkingOneDriveDataSubscription != null) {
        this.checkingOneDriveDataSubscription.unsubscribe();
      }
      this.checkingOneDriveDataSubscription = source.subscribe(val => {
        this.microsoftOffice365Service.checkOneDriveDataByProfileId(profileId)
          .subscribe(async resp => {
            if (resp?.result?.oneDriveData != null) {
              this.checkingOneDriveDataSubscription.unsubscribe();
              await this.handleAuthorizeOpenFolderUrl(resp.result.oneDriveData.oneDriveFolderId, resp.result.webUrl, toastRef);
            }
          })
      })
    } catch (error) {
      if (this.checkingOneDriveDataSubscription != null) {
        this.checkingOneDriveDataSubscription.unsubscribe();
      }
    }
    finally {
      this.isDoingCheckingOneDriveData = false;
    }
  }
  async handleAuthorizeOpenFolderUrl(folderId: string, folderWebUrl: string, toastRef: any) {
    try {
      const isUserExistOrganization = await this.userService.checkUserExistOrganization(this.user.nameid).toPromise();
      if (isUserExistOrganization && isUserExistOrganization.result) {
        const isGrantPermission = await this.userService.grantPermissionOpenFileOrFolder(this.user.nameid, folderId).toPromise();
        if (isGrantPermission && isGrantPermission.result) {
          if (folderWebUrl != null || folderWebUrl != "") {
            toastRef.close();
            window.open(`${folderWebUrl}`, '_blank');
          }
          else {
            toastRef.close();
            this.toast.warning("The Microsoft OneDrive folder URL of this Proposal is unavailable.", 'Warning');
          }
        }
        else {
          toastRef.close();
          this.toast.warning("Cannot grant permission to access this folder.", 'Warning');
        }
      } else {
        toastRef.close();
        this.toast.warning("You don't have permission to access this folder.", 'Warning');
      }
    }
    catch (error) {
      console.log(error);
    }
  }

  createFollowingUpTask() {
    try {
      if (!this.crmTaskService.isOpenTask) {
        if (!this.isOpenFollowUpTask) {
          let dialog = this.dialog.open(CrmTaskTemplateComponent, {
            disableClose: true,
            panelClass: 'dialog-detail',
            autoFocus: false,
            hasBackdrop: false,
            width: '350px',
            data: {
              currentProfile: this.opportunityModel,
              position: { left: '0', bottom: '0' }
            }
          });

          dialog.afterOpened().subscribe(() => {
            this.isOpenFollowUpTask = true;
          })

          dialog.afterClosed().subscribe(response => {
            if (response) {
              this.refreshTaskTab();
            }
            this.crmTaskService.isOpenTask = false;
            this.isOpenFollowUpTask = false;
          });
        }
      } else {
        if (this.crmTaskService.dialogTaskRef.componentInstance.isMinimize)
          this.crmTaskService.dialogTaskRef.componentInstance.minimizeDialog();
      }
    }
    catch (err) {
      console.error(err);
    }
  }

  async addVendorToOpportunity() {
    if (!this.id) {
      return;
    }

    // Warm the edit chunk while settings and existing clients are fetched. If the
    // selected client is a duplicate, the edit dialog is ready before it is needed.
    const editDialogLoadPromise = preloadEditProfileVendorDialog();
    const existingClientPage = new Page();
    existingClientPage.size = -1;

    const [roleSetting, existingClientResult] = await Promise.all([
      this.settingPoolService
        .getSettingByKeyAndGroup('SELECT_CLIENT_ROLE_ON_INIT', 'SALE_CONFIG')
        .toPromise()
        .catch(() => null),
      this.profileService
        .getProfileVendorPagingByProfileId(existingClientPage, this.id)
        .toPromise()
        .catch(() => null)
    ]);
    const roleSettingValue = roleSetting?.result?.value?.toString()?.toLowerCase() ?? '';
    const roleSettingEnabled = ['1', 'true'].includes(roleSettingValue);
    const defaultVendorRole = roleSettingEnabled
      ? 'NO_ROLE'
      : 'BOOKING_CONTACT';

    const existingProfileVendorsById = (existingClientResult?.result?.data ?? [])
      .reduce((result: Record<string, ProfileVendorModel>, profileVendor: ProfileVendorModel) => {
        const clientProfileId = profileVendor.vendorId ?? profileVendor.saleAccount?.profileId;
        if (clientProfileId) {
          result[clientProfileId] = profileVendor;
        }
        return result;
      }, {});

    const dialogRef = this.dialog.open(AddExistingProfileComponent, {
      width: '40vw',
      data: {
        id: this.id,
        isProfile: true,
        placeholder: 'Search Client',
        label: 'Client',
        apiSearch: (data) => this.accountService.searchSaleAccount(data),
        isListenEvent: true,
        firstSuggest: true,
        firstSuggestAPI: this.accountService.suggestRecentlyAddedSaleAccount(),
        idProp: 'profileId',
        showVendorRoles: true,
        defaultVendorRole,
        existingProfileVendorsById
      }
    });

    const chosenData = await dialogRef.afterClosed().toPromise();
    if (!chosenData) {
      return;
    }

    if (chosenData.action === EDIT_EXISTING_PROFILE_ACTION) {
      const duplicateSelection = chosenData as EditExistingProfileSelection;
      const editDialogRef = openEditProfileVendorDialog(
        this.dialog,
        duplicateSelection.profileVendor,
        editDialogLoadPromise
      );
      const updated = await editDialogRef.afterClosed().toPromise();
      if (updated) {
        this.vendorTab.refreshData();
      }
      return;
    }

    const model: AddProfileVendorViewModel = {
      profileId: this.id,
      profileType: ProfileType[ProfileType.OPPORTUNITY],
      vendorId: chosenData.profileId,
      vendorType: ProfileType[ProfileType.SALEACCOUNT],
      roles: chosenData.roles,
      isPrimary: chosenData.isPrimary,
      replaceExistingSigner: chosenData.replaceExistingSigner,
    };
    const savedResult = await this.opportunityService.createVendor(model).toPromise();
    if (savedResult != null && savedResult.result) {
      this.toast.success('Create Client Successfully!', 'Success');
      this.vendorTab.refreshData();
    } else {
      this.toast.danger(savedResult?.message || 'Unable to create Client', 'Error');
    }
  }

  async refreshLastContact() {
    await this.updateLastContact();
  }

  /**
   * Get the timezone offset in minutes for a given date or date string.
   * @param input The date or date string to get the offset for.
   * @returns The timezone offset in minutes, or 0 if an error occurs.
   */
  getTimeOffset(input: string | Date): number {
    try {
      if (!input) {
        console.error("[getTimeOffset] Input is null or undefined");
        return 0;
      }
      return new Date(input).getTimezoneOffset();
    }
    catch (error) {
      console.error("[getTimeOffset] Error:", error);
      return 0;
    }
  }

  /**
   * Convert a given date to UTC time considering the provided offset in minutes.
   * If no offset is provided, it calculates the offset based on the input date.
   * @param input The date to be converted.
   * @param offsetMinutes Optional offset in minutes. If not provided, it will be calculated.
   * @returns The UTC date or null if the input is invalid.
   */
  getUTCTime(input: Date, offsetMinutes?: number): Date | null {
    if (!input) {
      console.error("[getUTCTime] Input date is null or undefined");
      return input;
    }
    if (offsetMinutes == null || offsetMinutes === undefined || isNaN(offsetMinutes)) {
      offsetMinutes = this.getTimeOffset(input);
    }
    return new Date(input.getTime() - (offsetMinutes * 60 * 1000))
  }

  onSaveCloseLostReason(lostReason: string) {
    this.editOpportunity(lostReason, 'lostReason', this.TypeEditModelOpportunity.Opportunity);
  }

  get estimatePipeline(): number {
    try {
      const budget = Number(this.opportunityModel?.saleOpportunity?.amount);
      const clientFee = Number(this.opportunityModel?.profileAdditionDetail?.artistFeesToClient);

      if (!Number.isFinite(budget) || !Number.isFinite(clientFee) || budget === 0 || clientFee === 0)
        return 0;

      return parseFloat(((clientFee / budget) * 100).toFixed(2));
    } catch (error) {
      console.error(error);
      return 0;
    }
  }

  get isEstimatePipelineGood(): boolean {
    return this.estimatePipeline > this.estimatePipelineThreshold
  }

  convertHtmlToNormalStyle(data: string) {
    let tmp = document.createElement("DIV");
    tmp.innerHTML = data;
    return tmp.textContent || tmp.innerText || "";
  }

  openComponentEditor(model: string, prop: string) {
    this.dialogQuillEditor = this.dialog.open(this.popupEditor, {
      disableClose: true,
      autoFocus: false,
      width: '60vw',
      data: this.saleAccountModel[model][prop]
    });

    this.dialogQuillEditor.afterClosed().subscribe(resp => {
      if (resp) this.editClientDescription(resp, prop, model)
    });
  }

  async editClientDescription(value: any, prop: string, model: string) {
    if (!this.saleAccountModel?.saleLeadsContact) return;

    const contactId = this.saleAccountModel?.saleLeadsContact?.contactId;

    if (!contactId) {
      this.toast.danger('Contact not found', 'Error');
      return;
    }

    this.isLoadingEdit = true;    
    await this.editSaleAccount(value, prop, TypeEditModelOpportunity.Contact);
    this.isLoadingEdit = false;
  }

  setFocus(editor, data) {
    if (this.dialogQuillEditor) {
      const width = this.dialogQuillEditor._containerInstance._config.width;
      let toolbarEditor = this.quillEditor.elementRef.nativeElement.getElementsByClassName("ql-toolbar ql-snow")[0];
      toolbarEditor.style = `width: calc(${width} - 48px); background-color: snow; z-index: 100;`;
      let containerEditor = this.quillEditor.elementRef.nativeElement.getElementsByClassName("ql-container ql-snow")[0];
      containerEditor.style = `margin-bottom: 1px;`;
      this.contentQuillEditor = data;

      editor.focus();
    }
  }

  saveEditor() {
    if (this.dialogQuillEditor) {
      if (this.contentQuillEditor && this.contentQuillEditor !== "")
        this.closeDialogEditor(this.contentQuillEditor);
      else this.toast.danger("Content error or empty!", "Error");
    }
  }

  closeDialogEditor(data?: string) {
    if (this.dialogQuillEditor) this.dialogQuillEditor.close(data);
  }

  async loadLocationData() {
    try {
      const location = await this.locationService.getDefaultLocation().toPromise();
      if (location) {
        this.rawLocation = this.setupLocation(location);
        this.locationCountries = this.rawLocation.map(x => x.name);
        this.filteredCountries = [...this.locationCountries];
      }
    } catch (error) {
      console.error('Error loading location data:', error);
    }
  }

  setupLocation(location) {
    const locationLst = [];
    location.forEach(element => {
      const states = [];
      if (element.states && element.states.length > 0) {
        element.states.forEach(state => {
          const cities = [];
          if (state.cities && state.cities.length > 0) {
            state.cities.forEach(city => {
              cities.push(city.name);
            });
          }
          states.push({
            name: state.name,
            state_code: state.state_code,
            cities: cities
          });
        });
      }
      locationLst.push({
        name: element.name,
        iso2: element.iso2,
        states: states
      });
    });
    return locationLst;
  }

  onCountrySearch(country: string) {
    this.filteredCountries = this.filterList(this.locationCountries, country);
    this.onCountryChange(country, false);
  }

  onStateSearch(state: string) {
    this.filteredStates = this.filterList(this.locationStates, state);
    this.onStateChange(state, false);
  }

  private filterList(list: string[], value: string): string[] {
    const keyword = (value || '').toLowerCase().trim();
    if (!keyword) return [...list];

    return list.filter(x => x.toLowerCase().includes(keyword));
  }
  
  onCountryChange(country: string, shouldSave = true) {
    const selectedCountry = this.rawLocation.find(x => x.name === country);

    if (!selectedCountry) {
      this.locationStates = [];
      this.filteredStates = [];
      return;
    }

    this.locationStates = selectedCountry.states.map(x => x.name);
    this.filteredStates = [...this.locationStates];

    if (this.saleAccountModel?.saleLeadsContact?.location) {
      this.saleAccountModel.saleLeadsContact.location.country = country;
      this.saleAccountModel.saleLeadsContact.location.state = '';

      if (shouldSave) {
        this.filteredCountries = [...this.locationCountries];
        this.editSaleAccount(country, 'country', TypeEditModelOpportunity.Location);
      }
    }
  }

  onStateChange(state: string, shouldSave = true) {
    if (this.saleAccountModel?.saleLeadsContact?.location) {
      this.saleAccountModel.saleLeadsContact.location.state = state;

      if (shouldSave) {
        this.filteredStates = [...this.locationStates];
        this.editSaleAccount(state, 'state', TypeEditModelOpportunity.Location);
      }
    }
  }

  setupSaleAccount(id: string) {
    if (!id) return;
    
    this.accountService.refreshSaleAccountById(id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: resp => { 
          if (resp.result) {
            this.processSaleAccountData(resp.result);
          } 
        },
        complete: () => {
          this.getOwnerSaleAccount();
        },
      });
  }

  processSaleAccountData(data: SaleAccountDetailModel) {
    if (data) {
      this.saleAccountModel = data;
      
      // Setup tags
      this.saleAccountModel.tagList = this.saleAccountModel.tags !== '' && this.saleAccountModel.tags != null
        ? this.saleAccountModel.tags.split(',') : [];
      
      // Setup webPage array
      this.saleAccountModel.webPageArray = this.saleAccountModel?.webPage?.split(",")
        ?.map(x => x?.trim())
        ?.filter(x => !Helper.isNullOrEmpty(x)) || [];
      
      // Setup contact types
      this.selectType = this.saleAccountModel?.saleLeadsContact?.contactContactTypes?.map(x => x.contactTypeId) ?? [];
      if (this.allContactTypesAsDropdownModel.length > 0) {
        this.setupContactType();
      }
      
      // Setup Amount OpportunityValue & CurrentValue for CRM Mode
      if (this.isCRMMode == "1") {
        if (this.saleAccountModel?.profileAdditionDetail?.entityCount) {
          let counts = this.saleAccountModel.profileAdditionDetail.entityCount.split(',');
          for (let i = 0; i < counts.length; i += 2) {
            if (counts[i] === 'TotalOppoVal') {
              let amountOpportunityValueString = Helper.isNullOrEmpty(counts[i + 1]) ? "0" : counts[i + 1];
              this.amountOpportunityValue = parseInt(amountOpportunityValueString);
            }
            if (counts[i] === 'TotalCurVal') {
              let amountCurrentValueString = Helper.isNullOrEmpty(counts[i + 1]) ? "0" : counts[i + 1];
              this.amountCurrentValue = parseInt(amountCurrentValueString);
            }
          }
        }
        else {
          this.amountOpportunityValue = 0;
          this.amountCurrentValue = 0;
        }
      }
      
      // Load states if country exists
      if (this.saleAccountModel?.saleLeadsContact?.location?.country && this.rawLocation.length > 0) {
        const selectedCountry = this.rawLocation.find(x => x.name === this.saleAccountModel.saleLeadsContact.location.country);
        if (selectedCountry) {
          this.locationStates = selectedCountry.states.map(x => x.name);
          this.filteredStates = [...this.locationStates];
        }
      }
    }
  }

  getOwnerSaleAccount() {
    if (!this.saleAccountModel && (Helper.isNullOrEmpty(this.saleAccountModel.ownerId) || Helper.isEmptyOrSpaces(this.saleAccountModel.ownerId))) {
      this.saleAccountOwnerModel = Object.assign({ fullName: "Unknown" } as UserModel);
      return;
    }

    if (!this.saleAccountOwnerModel && this.saleAccountModel.ownerId)
      this.userService.getUserById(this.saleAccountModel.ownerId).pipe(takeUntil(this.destroy$))
        .subscribe(
          resp => {
            if (resp.result) {
              this.saleAccountOwnerModel = resp.result;
              let fullName = `${this.saleAccountOwnerModel.firstName} ${this.saleAccountOwnerModel.lastName}`;
              this.saleAccountOwnerModel.fullName = fullName.trim() ? fullName : "Unknown";
              this.saleAccountOwnerModel.pictureURL = Helper.userURL(this.saleAccountOwnerModel.pictureURL);
            };
          },
          err => this.saleAccountOwnerModel = Object.assign({ fullName: "Unknown" } as UserModel));
  }

  //#region START - Handle Multiple WebPage logic
  toggleWebPageView() {
    this.isShowAllWebPage = !this.isShowAllWebPage;
    this.refreshListWebPageShow();
  }

  addNewItem() {
    this.isShowAllWebPage = true;
    this.isAddNewWebPage = !this.isAddNewWebPage;
    if (this.isAddNewWebPage) {
      this.newWebPageValue = null;
      this.focusOnClickAddNewWebPage = true;
    }
    else {
      this.focusOnClickAddNewWebPage = true;
    }
  }

  refreshAddNewStateWebPage() {
    this.isAddNewWebPage = false;
    this.newWebPageValue = null;
  }

  refreshListWebPageShow() {
    let webPageArray: string[] = this.saleAccountModel?.webPage?.split(",");
    this.defaultWebPageItemToShow = this.isShowAllWebPage ? webPageArray?.length : 2;
  }

  async deleteNewWebPage(prop: string, typeModel: TypeEditModelOpportunity = TypeEditModelOpportunity.SaleAccount, propIndex?: number) {
    try {
      this.isLoadingDeleteWebpage = true;
      let value: any = "";

      if (propIndex == null) {
        this.refreshAddNewStateWebPage();
        this.isLoadingDeleteWebpage = false;
      }
      else {
        await this.editSaleAccount(value, prop, typeModel, propIndex);
        this.isLoadingDeleteWebpage = false;
      }
    }
    catch (ex) {
      this.isLoadingDeleteWebpage = false;
    }
  }

  handleOutFocusNewWebPage(value: boolean) {
    if (this.focusOnClickAddNewWebPage && value) {
      this.focusOnClickAddNewWebPage = false;
    }
  }

  saveIndividualProfileAdditionDetail(value: any, property: string) {
    if (!this.saleAccountModel?.profileAdditionDetail) return;

    this.saleAccountModel.profileAdditionDetail[property] = value;
    const saleAccountRequest = Object.assign({}, this.saleAccountModel);
    
    this.accountService.editSaleAccount({
      id: this.saleAccountModel.profileId,
      saleAccountModel: saleAccountRequest,
      contactModel: null,
      locationModel: null,
    }).pipe(takeUntil(this.destroy$))
      .subscribe({
        next: resp => {
          if (resp.result) {
            this.toast.success('Update success!', 'Success');
            this.setupSaleAccount(this.saleAccountModel.profileId);
          }
        },
        error: err => console.error('Error saving profile addition detail:', err)
      });
  }
  //#endregion END - Handle Multiple WebPage logic

  savePrimaryResellerOrRelationship = async (data: any, type: string) => {
    if (!this.saleAccountModel?.profileAdditionDetail) return;

    let dataId = data?.profileId;
    
    if (typeof (data) === 'string') {
      if (Helper.isNullOrEmpty(data)) {
        dataId = null;
      } else {
        this.toast.danger("Please input a valid data", 'Invalid Input');
        return;
      }
    }

    this.accountService.changePrimaryResellerOrRelationship(dataId, this.saleAccountModel.profileId, type).subscribe({
      next: res => {
        if (res.result) {
          this.toast.success(`Save primary ${type?.toLowerCase()} success!`, "Success");
          this.setupSaleAccount(this.saleAccountModel.profileId);
        }
      },
      error: (err) => { 
        console.error('Error saving relationship:', err); 
      },
    })
  }

  openParentClient: () => void = () => {
    const parentSaleAccountId: string = this.saleAccountModel?.profileAdditionDetail?.primaryRelationship;
    if (parentSaleAccountId) {
      const relationship = 'sale-account';
      Helper.pushBackURL();
      this.router.navigate([`/configuration/${relationship}/${parentSaleAccountId}`]);
    }
  }

  editNewSingleContactType(event: any, type: string) {
    if (!this.saleAccountModel?.saleLeadsContact?.contactId) return;

    if (event) {
      let id: number = parseInt(event.value);
      let selectedTarget = this.accountContactTypes.find(x => x.contactTypeId === id);
      if (selectedTarget) {
        if (type === 'parent') {
          if (!this.selectedContactTypeParent || (this.selectedContactTypeParent.value !== event.value)) {
            this.selectedContactTypeParent = event;
            this.selectedContactTypeChild = null;
            let newParent = this.accountContactTypes.find(x => x.contactTypeId === parseInt(this.selectedContactTypeParent.value));
            this._filterDropdownContactTypeChild(newParent);
          } else {
            return;
          }
        } else if (type === 'child') {
          if (!this.selectedContactTypeChild || (this.selectedContactTypeChild.value !== event.value)) {
            this.selectedContactTypeChild = event;
          } else {
            return;
          }
        }
      } else {
        return;
      }

      // Collect selected IDs
      let newIds = [];
      if (this.selectedContactTypeParent && !isNaN(parseInt(this.selectedContactTypeParent.value))) {
        newIds.push(parseInt(this.selectedContactTypeParent.value));
      }
      if (this.selectedContactTypeChild && !isNaN(parseInt(this.selectedContactTypeChild.value))) {
        newIds.push(parseInt(this.selectedContactTypeChild.value));
      }

      // Call API to update contact type
      this.contactService.editContactContactType(this.saleAccountModel.saleLeadsContact.contactId, newIds)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: resp => {
            if (resp.result) {
              this.toast.success(`Edit ${this.environment.titleAccount} success!`, "Success");
              this.setupSaleAccount(this.saleAccountModel.profileId);
            }
          },
          error: err => console.error('Error updating contact type:', err)
        });
    } else {
      // Remove contact type
      if (this.selectedContactTypeParent && type === 'parent') {
        this.selectedContactTypeParent = undefined;
        this.selectedContactTypeChild = undefined;
        this.subContactTypeAsDropdownModel = [];
        
        this.contactService.editContactContactType(this.saleAccountModel.saleLeadsContact.contactId, [])
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: resp => {
              if (resp.result) {
                this.toast.success(`Edit ${this.environment.titleAccount} success!`, "Success");
                this.setupSaleAccount(this.saleAccountModel.profileId);
              }
            },
            error: err => console.error('Error removing contact type:', err)
          });
      } else if (this.selectedContactTypeChild && type === 'child') {
        this.selectedContactTypeChild = undefined;
        const parentIds = this.selectedContactTypeParent ? [parseInt(this.selectedContactTypeParent.value)] : [];
        
        this.contactService.editContactContactType(this.saleAccountModel.saleLeadsContact.contactId, parentIds)
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: resp => {
              if (resp.result) {
                this.toast.success(`Edit ${this.environment.titleAccount} success!`, "Success");
                this.setupSaleAccount(this.saleAccountModel.profileId);
              }
            },
            error: err => console.error('Error removing child contact type:', err)
          });
      }
    }
  }

  setupContactType() {
    if (this.saleAccountModel?.profileId)
      this.selectType.forEach(item => {
        let itemInstance = this.accountContactTypes.find(x => x.contactTypeId == item);
        if (itemInstance && itemInstance.parentId > 0) {
          // if has parent: this is child:
          this.selectedContactTypeChild = new DropDownValue(itemInstance.contactTypeName, itemInstance.contactTypeId.toString(), itemInstance.contactTypeColorCode);
        }
        if (itemInstance && itemInstance.parentId == 0) {
          this.selectedContactTypeParent = new DropDownValue(itemInstance.contactTypeName, itemInstance.contactTypeId.toString(), itemInstance.contactTypeColorCode);
          // filter child dropdown:
          let childIds = this.accountContactTypes.slice().filter(x => x.parentId == itemInstance.contactTypeId).map(x => x.contactTypeId.toString());
          this.subContactTypeAsDropdownModel = this.allContactTypesAsDropdownModel.slice().filter(x => childIds.includes(x.value));
        }
      });
  }

  private _filterDropdownContactTypeChild(itemInstance: any) {
    if (!itemInstance) return;
    let childIds = this.accountContactTypes.slice().filter(x => x.parentId == itemInstance.contactTypeId).map(x => x.contactTypeId.toString());
    this.subContactTypeAsDropdownModel = this.allContactTypesAsDropdownModel.slice().filter(x => childIds.includes(x.value));
  }

  async editSaleAccount(value: any, prop: string, typeModel: TypeEditModelOpportunity = TypeEditModelOpportunity.SaleAccount, propIndex?: number) {
    if (!this.saleAccountModel) return;

    // Process with data prop type
    if ((prop == 'annualRevenue' || prop == 'noOfEmployee') && !value) value = 0;

    let saleAccountRequest: SaleAccountDetailModel, contactRequest: any, locationRequest: any;

    if (prop === 'channel') {
      if (this.saleAccountModel.profileAdditionDetail) {
        this.saleAccountModel.profileAdditionDetail[prop] = value;
      }
      saleAccountRequest = Object.assign({}, this.saleAccountModel);
      contactRequest = Object.assign({}, this.saleAccountModel.saleLeadsContact);
      locationRequest = Object.assign({}, this.saleAccountModel.saleLeadsContact?.location, { [prop]: value });
    } else {
      saleAccountRequest = Object.assign({}, this.saleAccountModel, { [prop]: value });
      contactRequest = Object.assign({}, this.saleAccountModel.saleLeadsContact, { [prop]: value });
      locationRequest = Object.assign({}, this.saleAccountModel.saleLeadsContact?.location, { [prop]: value });
    }

    // Logic for multiple WebPage
    let webPage: string;
    if (prop == "webPage") {
      if (propIndex != undefined) {
        let webPageArray: string[] = this.saleAccountModel.webPage?.split(",");
        webPageArray[propIndex] = value?.trim()?.toLowerCase();
        webPageArray = webPageArray.filter(x => !Helper.isNullOrEmpty(x));
        let filteredArray = webPageArray.map(url => url.replace(/^(https?:\/\/)?/, '').split('/')[0])
          .filter((item, index, self) => index === self.indexOf(item));
        webPage = filteredArray?.join(",");
      } else {
        if (Helper.isNullOrEmpty(this.saleAccountModel.webPage)) {
          webPage = value?.trim() || '';
          webPage = webPage.replace(/^(https?:\/\/)?/, '').split('/')[0];
          webPage = webPage.toLowerCase();
        } else {
          let webPageArray: string[] = this.saleAccountModel.webPage?.split(",");
          webPageArray.push(value?.trim()?.toLowerCase());
          webPageArray = webPageArray.filter(x => !Helper.isNullOrEmpty(x));
          let filteredArray = webPageArray.map(url => url.replace(/^(https?:\/\/)?/, '').split('/')[0])
            .filter((item, index, self) => index === self.indexOf(item));
          webPage = filteredArray?.join(",");
        }
      }
      saleAccountRequest.webPage = webPage;
    }

    let id;
    switch (typeModel) {
      case TypeEditModelOpportunity.SaleAccount:
        id = this.saleAccountModel.profileId;
        break;
      case TypeEditModelOpportunity.Contact:
        id = this.saleAccountModel.saleLeadsContact?.contactId?.toString();
        break;
      case TypeEditModelOpportunity.Location:
        id = this.saleAccountModel.saleLeadsContact?.locationId?.toString();
        break;
    }

    this.isLoadingEdit = true;
    this.accountService.editSaleAccount({
      id: id,
      saleAccountModel: typeModel == TypeEditModelOpportunity.SaleAccount ? saleAccountRequest : null,
      contactModel: typeModel == TypeEditModelOpportunity.Contact ? contactRequest : null,
      locationModel: typeModel == TypeEditModelOpportunity.Location ? locationRequest : null,
    }).pipe(takeUntil(this.destroy$))
      .subscribe({
        next: resp => {
          if (resp.result) {
            this.toast.success(`Edit ${this.environment.titleAccount} success!`, "Success");
            if (prop == "webPage" && !Helper.isNullOrEmpty(webPage)) {
              this.saleAccountModel.webPage = webPage;
              this.saleAccountModel.webPageArray = webPage?.split(",");
              this.refreshListWebPageShow();
              this.refreshAddNewStateWebPage();
            }
            // Refresh sale account data
            this.setupSaleAccount(this.saleAccountModel.profileId);
          }
        },
        error: err => this.isLoadingEdit = false,
        complete: () => this.isLoadingEdit = false
      });
  }
}

export enum TabOpportunity {
  Artist,
  Tasks,
  NonArtistIncome,
  NonArtistExpenses,
  Files,
  Note,
}

export enum TypeEditModelOpportunity {
  Opportunity,
  OpportunityProfile,
  SaleAccount,
  Contact,
  Location
}

export enum ProfileType {
  SALEPROFILE,
  SALEACCOUNT,
  LEADS,
  OPPORTUNITY,
  LEADS_VENUE
}
